let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
const params = new URLSearchParams(window.location.search);
const urlSource = params.get("url_source");
if (urlSource) {
  localStorage.setItem("traya_path_name", urlSource);
}
var id = getUrlParameter('id'), f_name = "", C_number = "", C_email = "", user__gender = "", firstFormFillDate = "", user_gender = "", rid = "", caseId = "", selectedStage = 'Stage-1';
var cohort = getUrlParameter('cohort'), variantsID = 0, recommended_products = [], variantsIDs = [];
if (cohort) { try { localStorage.setItem('cohort', cohort); } catch (e) {} } // carry cohort to checkout funnel
var prices = 0, doc__fee = 100000, diet__plan = 50000, hair__coach_fee = 50000, month1_total, month1DiscountPrice, month3DiscountPrice, month6DiscountPrice, discount_pricetext = 0;
let successfulFetchCount = 0, totalProducts = 0;
if (id) {
  localStorage.setItem('user-gender', 'male');
  localStorage.setItem('rid', id);
}
id = localStorage.getItem('rid');
if(id === undefined) {
  id = getCookie('syntheticId');
}
(function () {
  if(!id) {
    if(window.location.pathname == '/pages/result4c'){
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href= 'https://form.traya.health/questions?cohort=1&source=ResultPage'
    }
  var data_formPage = document.querySelectorAll('[data-formPage]'),
      data_resultPage = document.querySelectorAll('[data-resultPage]'),
      data_resultbtn = document.querySelectorAll('[data-resultbtn]'),
      data_notResult = document.querySelectorAll('[data-notResult]');
    if(data_formPage.length != 0) {
      data_formPage.forEach((formpage) => { formpage.style.display = "block"; });
    }
    if(data_resultPage.length != 0) {
      data_resultPage.forEach((resultpage) => { resultpage.style.display = "none"; });
    }
    if(data_resultbtn.length != 0) {
      data_resultbtn.forEach((resultbtn) => { resultbtn.style.display = "none"; });
    }
    if(data_notResult.length != 0) {
      data_notResult.forEach((notresult) => { notresult.style.display = "block"; });
    }
  }else {
    setotherCookie('syntheticId', id, 30, '.traya.health');
    var data_result = document.querySelectorAll('[data-result]');
    if(data_result.length != 0) {
      data_result.forEach((result) => { result.style.display = "block"; })
    }
  }
  var baseUrls = {
    DEV: 'https://api.dev.hav-g.in/',
    PROD: 'https://api.hav-g.in/'
  };
  var tokens = {
    DEV: { 
      "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
    },
    PROD: { 
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    }
  };
  var token = tokens.PROD;
  var baseUrl = baseUrls.PROD;
  var liveendpoint = 'https://api.hav-g.in/dgReport?id=';
  if (cohort == 2) {
    liveendpoint = baseUrl + 'dgReport/male/v4?id=';
  } else {
    liveendpoint = baseUrl + 'dgReport/male/v4?id=';
  }
  liveendpoint = baseUrl + 'dgReport/male/v4?id=';
  window.addEventListener('DOMContentLoaded', function() {
    var atcButton = document.querySelectorAll('#add-to-cart-result-page');
    if (atcButton.length !== 0) {
      atcButton.forEach((button) => {
        button.addEventListener('click', function () {
          button.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
          button.classList.add('loader-added')
          button.disabled = true;
          const addToCartEvent = 'result_add_to_cart';
          const addToCartEventData = { "gender": "Male" };
          Shopify.analytics.publish(addToCartEvent, addToCartEventData);
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 100); 
          setTimeout(() => {
            button.disabled = false;
            button.classList.remove('loader-added');
            button.style.textTransform = 'capitalize';
            button.innerHTML = `<span class="Rmoney_buy mr-1 mr-md-5">Buy Now</span>`;
            button.style.color = '#000';
          }, 1500);
        });
      });
    }
    getMaleResult(liveendpoint, id, token);
  })
})();

async function clearCart(caseId) {
  var _id = caseId || localStorage.getItem('caseId') || '';
  // Fetch cart state first to avoid calling clear.js on an already-empty cart.
  // Excessive clear.js calls on empty carts trigger Cloudflare bot detection on Shopify's CDN.
  let cartCount = 0;
  try {
    const cartState = await fetch('/cart.js').then(r => r.json());
    cartCount = cartState.item_count || 0;
  } catch (e) {
    console.error('Error fetching cart state: ', e);
  }
  if (cartCount === 0) return;

  var formdata = {
    sections: 'cart-drawer'
  };
  await fetch('/cart/clear.js', {
    method: "POST",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formdata)
  }).then((response) => {
    return response.json();
  }).then((result) => {
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer, drawer=false,0);
  }).catch((error) => {
    console.error('Error: ', error);
  })
}

// CAPI_TRACKING_API code
function trackMetaEvent(response, eventName) {
  function getCookieValue(cookieName) {
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(cookieName + '='));
    if (!cookie) return null;
    return cookie.trim().split('=').slice(1).join('=');
  }
  
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const user_gender = response.gender;
  const email = response.email;
  const phone = response.phone;
  
  const capiBody = {
    eventName: eventName,
    eventTime: Date.now(),
    email: email,
    phone: phone,
    fbc: fbc,
    fbp: fbp,
    url: window.location.href,
    domain: "traya.health",
    gender: user_gender
  };
  
  const CAPI_TRACKING_API = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  
  fetch(`${CAPI_TRACKING_API.PROD}tracking`, { method: 'POST', body: JSON.stringify(capiBody), headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    }
  });
}

async function getMaleResult(livepoint, id, token) {
  document.body.style.overflow = 'hidden';
  let _fetchedCaseId = '';
  try {
    const response = await fetch(`${livepoint}${id}&isWebsite=true`, {
      headers: token
    });
    const data = await response.json();
    const queryParams = window.location.search;
    if(data?.User_Analysis?.gender == 'F'){
      window.location.href = `/pages/female-result${queryParams}`;
    }
    if (data.message && data.message === "Report is only for female") {
      window.location.href = `/pages/female-result${queryParams}`;
      return;
    }
    if (data.message && data.message === "Report is only for female") {
      window.location.href = `/pages/female-result${queryParams}`;
      return;
    }
  
    const caseId = String(data?.User_Analysis?.case_id).trim();
    _fetchedCaseId = caseId;
    tagClarityCaseId(caseId);
    const geneticAnswer = data?.Recommendations?.Genetic;
    const stage = data?.currentStage?.stage;
    const allowedStages = ["Stage-2", "Stage-3", "Stage-4", "Stage-5"];
    firstFormFillDate = data.firstFilledFormDate;

    // Stage gate: result4c only handles Stage-2 through Stage-5.
    // Any other stage (Stage-1, Stage-6, Heavy Hair Fall, Coin Size Patch) → redirect to result4.
    if (stage && !allowedStages.includes(stage)) {
      window.location.href = `/pages/result4${queryParams}`;
      return;
    }

    // ─────────────────────────────────────────────────────────────────────────
    // REMOVED: Native cohort redirect (case_id starting with 1, 5, 6, 7)
    // Previously these users were force-redirected from result4c → result4 on
    // the result.traya.health subdomain. Disabled on [DATE] as part of [reason —
    // e.g. "rolling out result4c to native cohort" / "A/B test winner"].
    // Keeping commented for ~1 release cycle in case rollback is needed.
    // ─────────────────────────────────────────────────────────────────────────
    // const nativeVariationUsers = ['1', '5', '6', '7'];
    // const nativeIsVariationUser = nativeVariationUsers.includes(caseId.charAt(0).toLowerCase());
    // if (nativeIsVariationUser) {
    //   window.location.href = `https://result.traya.health/pages/result4${queryParams}`;
    //   return;
    // }
    console.log("Fetched caseId:", caseId);
    headerLanguageSelector();
    initStageProgressionExperiment(data);   // ← add this line
    ShowContent(data);
    fireResultPageLandedEvent(data);
    const currentStage = data?.currentStage?.stage?.match(/\d+/)[0];
    replaceWithGeneticContent(data.Recommendations, currentStage);
    rootCause(data?.root_causes);
    resultMonthKit(data);
    if (String(data?.Recommendations?.Minoxidil).trim().toLowerCase() !== 'yes') {
      var footnotes = document.querySelectorAll('.clinical-study-note');
      if (footnotes.length >= 3) footnotes[2].style.display = 'none';
    }
    displayProduct(data);
    getProductByHandle(data);
    initResult4bYouSave(data);   // ← add this
    // initStickyNoteVariation(data);   // ← add this line
    trackMetaEvent(data.User_Analysis, "Viewed Content");
     updateAddonPricesForVariation(data); 
    initAyurvedicBanner(data); 
     // ── 90-day retake banner ──
    const retakeOutcome = check90DayRetake(data);
    if (retakeOutcome) {
      // renderRetakeBanner(retakeOutcome);
      fireRetake90DaysEvent(retakeOutcome, data);
    }
    displayStageSection(data);
    successRateDataFetch(data);
    sectionMonthsExpectetion(data);
    sectionRealStories(data);
    initKitBannerCTA(data);
    reorderKitBannerForMobile();
    // testimonial video component
    const firstChar = caseId.charAt(0);
    const videoVariationUsers = ['8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
    let realStoriesWrappers = document.querySelector('.real-stories-wrapper');
    let imageCarouselContainerStories = document.querySelector('section.image-carousel--container');
    const stageEligible  = currentStage?.includes('3') ?? false;
    if (stageEligible) {
      realStoriesWrappers.classList.remove('d-none');
      imageCarouselContainerStories.classList.add('d-none');
    } else {
      realStoriesWrappers.classList.add('d-none');
      imageCarouselContainerStories.classList.remove('d-none');
    }
  } catch (error) {
    console.error('Error: ', error);
    document.body.style.overflow = 'unset';
  } finally {
    await clearCart(_fetchedCaseId);
    checkout();
  }
}

function fireResultPageLandedEvent(response) {
  const pathMatch = window.location.pathname.match(/\/pages\/([^/?]+)/);
  const result_variant = pathMatch ? pathMatch[1] : 'unknown';
  const form_variant = localStorage.getItem('traya_path_name') || '';

  const rawGender = response?.User_Analysis?.gender || '';
  const gender =
    rawGender === 'F' ? 'Female' : rawGender === 'M' ? 'Male' : rawGender;

  const caseId = response?.User_Analysis?.case_id || '';
  const urlParams = new URLSearchParams(window.location.search);
  const utm_source = urlParams.get('utm_source');
  const utm_medium = urlParams.get('utm_medium');
  const utm_campaign = urlParams.get('utm_campaign');
  const referrer = document.referrer;
  let hairLineAiImage = document.querySelector('.stage-hair-ai-image img');
  const hasAiImage = !!(response?.hairAIData?.image_b64 && hairLineAiImage);

  const eventPayload = {
    result_variant,
    form_variant,
    gender,
    case_id: caseId,
    page_url: window.location.href,
    ai_image: hasAiImage ? 'yes' : 'no',
  };

  if (utm_source)   eventPayload.utm_source   = utm_source;
  if (utm_medium)   eventPayload.utm_medium   = utm_medium;
  if (utm_campaign) eventPayload.utm_campaign = utm_campaign;
  if (referrer)     eventPayload.referrer     = referrer;

  if (typeof gtag === 'function') {
    gtag('event', 'result_page_landed', {
      send_to: 'G-KJK84KP0LJ',
      ...eventPayload,
    });
  }
}

function initFreeAddonPopup(caseId) {
  const firstChar = caseId.charAt(0);
  const variationUsers = ['d', 'e', 'f', '1', '5', '6', '7', '9'];
  if (!variationUsers.includes(firstChar)) {
    return;
  }
  let dropdownArrow = document.querySelectorAll('.dropdown-arrow');
  dropdownArrow.forEach((arrow)=>{
    arrow.classList.remove('d-none');
  }) 
  const popup = document.querySelector('.free-addon-male-popup');
  const overlay = document.querySelector('.free-addon-male-overlay');
  const closeBtn = document.querySelector('.free-addon-male-close');
  const triggers = document.querySelectorAll('.hair_thinning_kit--image-container');
  const sliderElement = document.querySelector('.free-addon-male-slider');
  const stickyBtn = document.querySelector('#sticky-btn')
  if (!popup || !overlay || !sliderElement) return;
  const $slider = $('.free-addon-male-slider');

  if (!$slider.hasClass('slick-initialized')) {
    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {

      const current = (currentSlide ? currentSlide : 0);
      const total = slick.slideCount;

      const dots = document.querySelectorAll('.slick-dots li');

      dots.forEach((dot, index) => {
        const button = dot.querySelector('button');

        if (index === current) {
          button.innerHTML = `${current + 1}/${total}`;
          dot.classList.add('slick-counter-active');
        } else {
          button.innerHTML = '';
          dot.classList.remove('slick-counter-active');
        }
      });

    });

    $slider.slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300
    });
  }

  triggers.forEach((item, index) => {
    item.addEventListener('click', function () {
      popup.classList.add('active');
      overlay.classList.add('active');
      document.body.classList.add('overflow-hidden');
      if (stickyBtn) stickyBtn.classList.add('d-none');
      $slider.slick('slickGoTo', index);
      // Add this
      document.querySelectorAll('.timeline-dot-line, .switch, .image-carousel--container').forEach(el => {
        el.style.opacity = 0.2;
        el.style.pointerEvents = 'none';
      });
      document.querySelectorAll('.timeline-dot-line, #timeline--container').forEach(el => {
        el.style.pointerEvents = 'none';
      });
    });
  });

  function closePopup() {
    popup.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = "";
    document.body.classList.remove('overflow-hidden');
    if (stickyBtn) stickyBtn.classList.remove('d-none');
    // Add this
    document.querySelectorAll('.timeline-dot-line, .switch, .image-carousel--container').forEach(el => {
      el.style.opacity = 1;
      el.style.pointerEvents = 'auto';
    });
    document.querySelectorAll('.timeline-dot-line, #timeline--container').forEach(el => {
      el.style.pointerEvents = 'auto';
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);
}



// ── Ayurvedic Banner A/B Test ──────────────────────────────────────────────
// Helper: finds the free add-ons inline section using multiple strategies
function findFreeAddonSection() {
  // Strategy 1: common class names — update the first one to your real class
  const byClass =
    document.querySelector('.free-addons-section') ||       // ← replace with your real class
    document.querySelector('.free-addon-section') ||
    document.querySelector('.hair_thinning_kit-container') ||
    document.querySelector('[class*="free-addon"]') ||
    document.querySelector('[class*="free-add-on"]') ||
    document.querySelector('[class*="addon"]') ||
    null;

  if (byClass) {
    console.log('[AyurvedicBanner] Found by class:', byClass.className);
    return byClass;
  }

  // Strategy 2: find by "FREE ADD-ONS" text content anywhere on page
  const allDivs = document.querySelectorAll('div, section');
  for (const el of allDivs) {
    // Only check direct text, not deep children (avoid matching the whole page)
    const directText = Array.from(el.childNodes)
      .filter(n => n.nodeType === Node.TEXT_NODE || (n.nodeType === Node.ELEMENT_NODE && ['P','SPAN','DIV','H2','H3','H4'].includes(n.tagName)))
      .map(n => n.textContent?.trim().toUpperCase())
      .join('');
    if (directText.includes('FREE ADD-ONS') || directText.includes('FREE ADD-ON')) {
      console.log('[AyurvedicBanner] Found by text content:', el.className);
      return el;
    }
  }

  return null;
}

/**
 * Control  (A,b,c,0,2,3,4,8) → no banner
 * Variation 1 (D,e,f,1)       → below product cards (attached to card list)
 * Variation 2 (5,6,7,9)       → below free add-ons component
 *
 * Single banner node is inserted and CSS handles mobile/desktop visibility.
 */
function initAyurvedicBanner(response) {
  const caseId = String(response?.User_Analysis?.case_id).trim();
  // Variation 1: 100% of all users get SVG text banner
  initAyurvedicBannerVar1(caseId);

  // Variation 2: image banner for 5,6,7,9 — unchanged
  // const caseId = String(response?.User_Analysis?.case_id ?? '').trim();
  // if (!caseId) return;
  // const firstChar = caseId.charAt(0).toLowerCase();
  // const VAR2_CHARS = new Set(['5', '6', '7', '9']);
  // if (VAR2_CHARS.has(firstChar)) {
  //   initAyurvedicBannerVar2();
  // }
}

// ── Variation 1 (d,e,f,1) ─────────────────────────────────────────────────
// Simple SVG + text banner, created by JS, attached below product cards
function initAyurvedicBannerVar1(caseId) {
  const kitSection = document.querySelector('.shopify-kit-section');
  if (!kitSection) {
    console.warn('[AyurvedicBanner] Var1: .shopify-kit-section not found.');
    return;
  }
  const banner = document.createElement('div');
  banner.className = 'ayurvedic-tag-banner';
  banner.innerHTML = `
    <span class="ayurvedic-tag-banner__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="24" viewBox="0 0 28 24" fill="none">
        <g clip-path="url(#clip0_52284_413376)">
          <path d="M22.3945 2.98047C22.8406 2.32072 23.732 2.15083 24.3848 2.60352L26.4492 4.03125L26.5137 4.07617V4.08008C26.9567 4.42335 27.1638 4.99793 27.0381 5.55176C26.87 6.29174 26.1673 6.76799 25.4346 6.65723L24.085 9.0127C25.0083 9.16405 25.7725 9.84088 26.0342 10.7627C26.3947 12.033 25.699 13.3568 24.4707 13.7744C24.3379 17.6377 21.6821 20.9399 17.9717 21.8516C17.9505 22.9806 17.0417 23.8919 15.918 23.8926H11.1367C10.0136 23.8913 9.10548 22.98 9.08496 21.8516C5.37341 20.9404 2.71484 17.6377 2.58203 13.7734C1.59675 13.4358 0.927717 12.5004 0.927734 11.4414C0.92786 10.0822 2.01679 8.97644 3.36328 8.97656H18.8359L22.335 4.51758C22.0634 4.03899 22.083 3.44133 22.3945 2.98047ZM16.8135 22.0508C16.5286 22.0803 16.2425 22.0972 15.9561 22.0977H11.1016C10.8149 22.0973 10.5283 22.0814 10.2432 22.0518C10.3467 22.4589 10.7111 22.7547 11.1377 22.7559H15.917C16.3445 22.7551 16.7096 22.4588 16.8135 22.0508ZM3.71582 13.9072C3.94333 17.8625 7.17693 20.9644 11.1016 20.9609H15.9551C19.879 20.9635 23.1117 17.8618 23.3389 13.9072H3.71582ZM3.36328 10.1133C2.7032 10.1133 2.14429 10.6126 2.06348 11.2803C1.9753 12.0105 2.48777 12.6718 3.2041 12.7607H3.20508C3.22534 12.7634 3.23949 12.7673 3.25293 12.7725C3.25203 12.7721 3.24954 12.7713 3.24707 12.7705C3.24344 12.7693 3.23982 12.7684 3.23633 12.7676C3.2303 12.7662 3.22559 12.7656 3.22559 12.7656C3.23427 12.7664 3.26733 12.7676 3.38281 12.7686C3.60743 12.7705 4.1215 12.7721 5.31348 12.7725C7.69717 12.7731 12.7902 12.7715 23.6943 12.7715H23.6963C24.4171 12.7708 25.0045 12.1773 25.0039 11.4424C25.0027 10.707 24.4147 10.1145 23.6934 10.1133H3.36328ZM20.2715 8.97656H22.8066L24.4277 6.14355L23.1738 5.27637L20.2715 8.97656ZM23.749 3.54102C23.6098 3.44481 23.4191 3.48067 23.3232 3.62305C23.2267 3.76661 23.2641 3.96165 23.4043 4.05859L25.459 5.47852L25.4629 5.48047H25.4619C25.4631 5.48118 25.4647 5.48266 25.4658 5.4834H25.4648C25.4672 5.48489 25.4694 5.48667 25.4717 5.48828H25.4727C25.6117 5.58123 25.7993 5.5449 25.8945 5.4043L25.9248 5.34863C25.9806 5.21367 25.9363 5.05274 25.8135 4.96777L23.749 3.54102Z" fill="#556417" stroke="#556417" stroke-width="0.3"/>
          <path d="M6.28418 0.133789C7.33789 0.0484074 8.66732 0.143629 9.77637 0.870117C10.7382 1.50075 11.3398 2.47939 11.7129 3.38379C12.0657 4.23905 12.218 5.04099 12.2793 5.44922L13.3223 6.13281C13.3337 6.1397 13.3446 6.14735 13.3545 6.1543H13.3555C13.61 6.33388 13.6713 6.68675 13.4951 6.94336C13.3188 7.19996 12.9704 7.26506 12.7148 7.08789L11.668 6.40137C10.0327 6.86384 7.98209 6.92266 6.51758 5.96191C5.40951 5.23535 4.78007 4.04625 4.42578 3.03809C4.07056 2.02725 3.9845 1.17695 3.97754 1.10254C3.95324 0.841925 4.10878 0.596731 4.35645 0.511719H4.35742C4.42588 0.488903 5.22755 0.219457 6.28418 0.133789ZM6.87891 1.24512C6.19454 1.24989 5.57196 1.36724 5.17188 1.46387C5.24965 1.87345 5.40003 2.49864 5.67676 3.13477C5.98739 3.84878 6.45015 4.56329 7.13086 5.00977C8.10136 5.64549 9.37429 5.64637 10.3203 5.51855L7.84082 3.8916V3.89062C7.83139 3.88477 7.82185 3.87989 7.81348 3.87402C7.55873 3.69445 7.49643 3.34069 7.67285 3.08398C7.84904 2.8277 8.19765 2.76277 8.45312 2.93945L10.9277 4.5625C10.6555 3.63522 10.133 2.45931 9.16309 1.82324C8.48017 1.37562 7.64788 1.23978 6.87891 1.24512Z" fill="#556417" stroke="#556417" stroke-width="0.3"/>
        </g>
        <defs>
          <clipPath id="clip0_52284_413376">
            <rect width="28" height="24" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </span>
    <span class="ayurvedic-tag-banner__text">
      Suppplements & Oil are ayurvedic with no known side effects<sup>+</sup><br>
    </span>
  `;

  kitSection.insertAdjacentElement('afterend', banner);
}

// ── Variation 2 (5,6,7,9) ─────────────────────────────────────────────────
// Image banner added via customizer (.ayurveda-banner-male), placed below free add-ons
function initAyurvedicBannerVar2() {
  const banner = document.querySelector('.ayurveda-banner-male');
  if (!banner) {
    console.warn('[AyurvedicBanner] Var2: .ayurveda-banner-male not found in DOM.');
    return;
  }

  if (window.innerWidth <= 767) {
    // Mobile: move banner OUTSIDE wrapper so it breaks free of container padding
    const wrapper = document.querySelector('.result-product-kit-wrapper');
    if (!wrapper) {
      console.warn('[AyurvedicBanner] Var2: .result-product-kit-wrapper not found.');
      return;
    }
    wrapper.insertAdjacentElement('afterend', banner);
  } else {
    // Desktop: place after free add-ons section inside wrapper
    const freeAddonSection = findFreeAddonSection();
    if (!freeAddonSection) {
      console.warn('[AyurvedicBanner] Var2: free add-ons section not found.');
      return;
    }
    freeAddonSection.insertAdjacentElement('afterend', banner);
  }

  banner.style.setProperty('display', 'block', 'important');
  banner.style.setProperty('width', '100%', 'important');
}

const geneticStageContent = {
  "Stage-2": {
    headline: "Your hair fall is Genetic, but Don't Worry!",
    text: [
      "This is caused by internal hormones attacking your hair follicles.",
      "At your stage, most hair follicles are still active. Starting your customised plan now will show results in 5–6 months."
    ]
  },
  "Stage-3": {
    headline: "Your hair fall is Genetic, but Don't Worry!",
    text: [
      "This is caused by internal hormones attacking your hair follicles.",
      "At your stage, hair follicles are actively shrinking. Start soon to increase your chances of hair regrowth."
    ]
  },
  "Stage-4": {
    headline: "Your hair fall is Genetic, but Don't Worry!",
    text: [
      "This is caused by internal hormones attacking your hair follicles.",
      "Hair fall at this stage can be reversed with consistent, long-term usage of your recommended customised plan."
    ]
  },
  "Stage-5": {
    headline: "Your hair fall is Genetic, but Don't Worry!",
    text: [
      "This is caused by internal hormones attacking your hair follicles.",
      "This stage of hair fall is difficult to reverse, but is possible with long-term consistent usage of your recommended customised plan."
    ]
  }
};

function replaceWithGeneticContent(recommendation, currentStage) {
  if (!recommendation || recommendation.Genetic !== "Yes") return;

  const container = document.getElementById("stageDescription");
  if (!container) return;

  const stageKey = `Stage-${currentStage}`;
  const content = geneticStageContent[stageKey];

  if (!content) return;
  const listItems = content.text.map(t => `<li>${t}</li>`).join("");
  // Completely replace existing HTML
  container.innerHTML = `
    <div class="genetic-box">
      <h3 class="genetic-headline">${content.headline}</h3>
      <ul class="genetic-list">
        ${listItems}
      </ul>
    </div>
  `;
}

function headerLanguageSelector() {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("id");
  const currentPage = params.get("page");
  if (!id) return;
  const langMap = {
    english: "_l_english",
    telugu: "_l_telugu",
    tamil: "_l_tamil"
  };

  const baseUrls = {
    english: "https://traya.health/pages/result4",
    telugu: "https://result.traya.health/pages/result4",
    tamil: "https://result.traya.health/pages/result4"
  };

  // Decide allowed languages
  let allowedLangs = ["english", "telugu", "tamil"];

  if (currentPage === "_l_telugu") {
    allowedLangs = ["english", "telugu"];
  } else if (currentPage === "_l_tamil") {
    allowedLangs = ["english", "tamil"];
  }

  const headerLanguageIcon = document.getElementById("language-icon-toggle");
  const headerLanguageDropdown = document.getElementById("language-dropdown-toggle");
  const headerWrapper = document.querySelector(".icons-flex-container");

  if (!headerLanguageDropdown) return;

  // ✅ SHOW ICON ONLY FOR TELUGU / TAMIL
  if (headerLanguageIcon) {
    if (currentPage === "_l_telugu" || currentPage === "_l_tamil") {
      headerLanguageIcon.classList.remove("d-none");
    } else {
      headerLanguageIcon.classList.add("d-none");
    }
  }

  // Update links + filter languages
  document.querySelectorAll("#language-dropdown-toggle .language-option").forEach(link => {
    const lang = link.getAttribute("hreflang");
    const pageParam = langMap[lang];
    const baseUrl = baseUrls[lang];

    if (!allowedLangs.includes(lang)) {
      link.style.display = "none";
      return;
    }

    link.style.display = "block";

    if (pageParam && baseUrl) {
      link.href = `${baseUrl}?id=${id}&page=${pageParam}`;
    }
  });

  // Dropdown toggle logic
  const langBtn = document.querySelector('.language-icon-toggle');
  const arrowIcon = document.querySelector('.language-arrow-icon');
  const langDropdown = document.querySelector('.language-dropdown');

  langBtn?.addEventListener('click', () => {
    langDropdown?.classList.toggle('open');
    langBtn.classList.toggle('white-background');
    arrowIcon?.classList.toggle('rotate');
  });

  headerLanguageIcon?.addEventListener("click", (e) => {
    e.stopPropagation();
    headerLanguageDropdown.classList.toggle("hidden");
    headerWrapper?.classList.toggle("hidden-dropdown");
  });
}
// Checking Eligibility
function checkEligibility() {
  document.querySelector('.checking-container').style.display = 'none';
  document.querySelector('.loading-container').style.display = 'flex';
  
  setTimeout(() => {
    document.querySelector('.loading-container').style.display = 'none';
    document.querySelector('.eligibilty-result').style.display = 'block';
  }, 1000); 
}
        
// doctor assigned section
function sectionCoach(response) {
  let stagesDoctorAssigned = response.currentStage;
  let assignedDoctor = document.querySelector('.doctor-assigned');
  let assignedDoctorPending = document.querySelector('.doctor-assigned--pending');
  const responseStage = stagesDoctorAssigned.stage; 
  
  if(assignedDoctor || assignedDoctorPending){
    if (responseStage === 'Stage-1') {
      assignedDoctor.style.display = 'block'; 
      assignedDoctorPending.style.display = 'none';
    } else {
      assignedDoctor.style.display = 'none';
      assignedDoctorPending.style.display = 'block';
    }
  }
}

// Function to determine if the device is mobile
function isMobileDevice() {
  return window.innerWidth <= 767;
}

function showProductDetails(productId, language, productIdsArray) {
  if (!productId) {
    console.error('Product ID is undefined');
    return;
  }
  createProductPopup(productId, productIdsArray);
}

// Function to create and display popup with product details
// The drawer iframe is created once and reused across opens — recreating it
// reboots the whole drawer app (form.traya.health) on every tap. sandbox omits
// allow-top-navigation so nothing inside the drawer can redirect the result page.
let drawerIframe = null;
let drawerProductId = null;
let drawerLoadTimer = null;

function createProductPopup(productId, productIdsArray) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: {
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: {
      "Link": "form.traya.health"
    }
  };

  const idsToSend = productIdsArray && productIdsArray.length
    ? productIdsArray
    : [productId];

  const encrypted = encryptProductIds(idsToSend);
  const iframeUrl = `https://${siteUrl.prod.Link}/product-drawerv4/${productId}?products=${encrypted}&lang=en`;

  if (!drawerIframe) {
    // src must be set at creation: a src-less iframe fires a load event for
    // about:blank, which would hide the spinner before the app has booted.
    popupContentPlaceholder.style.position = 'relative';
    popupContentPlaceholder.innerHTML = `
      <div id="drawer-loading-state" style="position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;background:#fff;z-index:1;">
        <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" alt="Loading..." width="48" height="48">
        <button id="drawer-retry-btn" type="button" style="display:none;border:1px solid #414B3B;background:#fff;color:#414B3B;border-radius:8px;padding:10px 24px;font-size:14px;">Taking too long? Tap to retry</button>
      </div>
      <iframe id="product-drawer-iframe" src="${iframeUrl}" frameborder="0" width="100%" height="100%" sandbox="allow-scripts allow-same-origin allow-forms allow-popups"></iframe>
    `;
    drawerIframe = document.getElementById('product-drawer-iframe');
    drawerIframe.addEventListener('load', onDrawerLoaded);
    document.getElementById('drawer-retry-btn').addEventListener('click', function () {
      loadDrawerUrl(drawerIframe.getAttribute('src'));
    });
    drawerProductId = productId;
    armDrawerLoading();
  } else if (drawerProductId !== productId) {
    // Only reload the drawer app when a different product is requested;
    // reopening the same product shows the already-loaded drawer instantly.
    drawerProductId = productId;
    loadDrawerUrl(iframeUrl);
  }

  if (isMobileDevice()) {
    popup.style.bottom = '0';
  } else {
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  document.querySelector('#product-popup #close-popup')?.addEventListener('click', closeProductPopup, { once: true });
  overlay.addEventListener('click', closeProductPopup, { once: true });
}

function armDrawerLoading() {
  const loadingState = document.getElementById('drawer-loading-state');
  const retryBtn = document.getElementById('drawer-retry-btn');
  loadingState.style.display = 'flex';
  retryBtn.style.display = 'none';
  clearTimeout(drawerLoadTimer);
  drawerLoadTimer = setTimeout(function () {
    retryBtn.style.display = 'block';
  }, 15000);
}

function loadDrawerUrl(url) {
  armDrawerLoading();
  drawerIframe.setAttribute('src', url);
}

function onDrawerLoaded() {
  clearTimeout(drawerLoadTimer);
  const loadingState = document.getElementById('drawer-loading-state');
  if (loadingState) loadingState.style.display = 'none';
  fireEvent("product_drawer_loaded", caseId, {
    productId: drawerProductId,
    daysSinceFormFill: firstFormFillDate ? getDaysSince(firstFormFillDate) : null
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

function getDaysSince(apiDate) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const pastDate = new Date(apiDate);
  pastDate.setHours(0, 0, 0, 0);
  const diffMs = today - pastDate;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24)); 
}

// Function to add click event listener to month kit product cards
function addClickEventListernerToMonthkit(productIdsArray) {
  document.querySelectorAll('.shopify-kit-section .kit-card-container').forEach((kit) => {
    kit.addEventListener('click', function (event) {
      // click event here product_click firstFormFillDate
      const productId = event.currentTarget.getAttribute('data-product-id');
      const language = 'english'; 
      showProductDetails(productId, language, productIdsArray);
      const daysSince = getDaysSince(firstFormFillDate); 
      fireEvent("product_click", caseId, daysSince, window.location.href);
    });
  });
}

// Function to create the month kit section
function resultMonthKit(response) {
  const productData = response.product_Ids;
  const priceCart = response.cart_price
  const productIdsArray = productData.map(p => p.product_id);
  const containerDiv = document.querySelector('.result-product-kit-wrapper');

  const header = document.createElement('h2');
  header.classList.add('kit-header', 'section-heading-font');
  const devidePriceCart = Math.round(priceCart / 34);
  const checkCaseId = String(response?.User_Analysis?.case_id).trim();
  const age = Number(response?.User_Analysis?.age);
  const firstChar = checkCaseId ? checkCaseId.charAt(0).toLowerCase() : '';
  const stage18 = response?.currentStage?.stage;
  const allowedStages18 = ["Stage-1", "Stage-2", "Stage-3"];
  if (allowedStages18.includes(stage18) && !Number.isNaN(age) && age >= 18 && age <= 24) {
    header.innerHTML = `<p class="variation-plan-heading">Your personalised hair care plan <br>At just <span class="green-text"><span class="total-devide-price">₹${devidePriceCart}</span> / day</span></p>`;
    document.querySelector('.age-results-faster-mini')?.classList.remove('d-none');
  } else {
    header.innerText = 'Start your journey with just 1 month kit';
  }
  containerDiv.appendChild(header);

  if(window.innerWidth <= 767){
    containerDiv.classList.remove('container');
  }

  const newSection = document.createElement('section');
  newSection.classList.add('shopify-kit-section');

  // new json data for the title and descritpion
  const updatedDataFromAPI = [
    {
      "variantId": "46528923304114",
      "name": "For Advanced Dandruff",
      "one_liner": "Advanced Anti-Dandruff Solution for stubbon dandruff"
    },
    {
      "variantId": "47329496826034",
      "name": "For Dandruff",
      "one_liner": "Anti-Dandruff Shampoo with proven actives"
    },
    {
      "variantId": "46466574909618",
      "name": "For Dandruff",
      "one_liner": "Anti-Dandruff Shampoo with proven actives"
    },
    {
      "variantId": "41645770309810",
      "name": "For Hair Regrowth",
      "one_liner": "Recap Serum with Hair Growth Actives"
    },
    {
      "variantId": "47329517568178",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 2% that prevents hormone led hair damage"
    },
    {
      "variantId": "47302891929778",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 5% that prevents hormone led hair damage"
    },
    {
      "variantId": "47301151064242",
      "name": "For Hair Hygiene",
      "one_liner": "Defence Shampoo for pH balance (SLS Free)"
    },
    {
      "variantId": "44650256728242",
      "name": "For Hair Texture",
      "one_liner": "Defence Conditioner for hydrated hair (SLS Free)"
    },
    {
      "variantId": "47276533121202",
      "name": "For Sleep",
      "one_liner": "Nasal Ghrit for restful sleep"
    },
    {
      "variantId": "46528902496434",
      "name": "For Digestion",
      "one_liner": "Gut Shuddi for constipation relief"
    },
    {
      "variantId": "46528906821810",
      "name": "For Hair Nutrition",
      "one_liner": "Hair Ras for hair nourishment"
    },
    {
      "variantId": "47303072710834",
      "name": "For Hairfall Control",
      "one_liner": "Hair Vitamin with natural hormone-blockers"
    },
    {
      "variantId": "47276523749554",
      "name": "For Metabolism",
      "one_liner": "Health Tatva for improved energy"
    },
    {
      "variantId": "46531537273010",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for scalp health"
    },
    {
      "variantId": "46530268987570",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for stress"
    },
    {
      "variantId": "46531521872050",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for hair growth"
    },
    {
      "variantId": "46530365751474",
      "name": "For Scalp Health",
      "one_liner": "Scalp Oil with booster for dandruff control"
    },
    {
      "variantId": "46528963936434",
      "name": "For Digestion",
      "one_liner": "Digest Boost for Gas and Bloating Relief"
    },
    {
      "variantId": "47302951403698",
      "name": "For Hair Nutrition",
      "one_liner": "Nourish Oil for adding shine to dull hair"
    },
    {
      "variantId": "47301148803250",
      "name": "For Hair texture",
      "one_liner": "Serum for Frizz-free, shiny hair"
    },
    {
      "variantId": "46465792704690",
      "name": "For Hair Nourishment",
      "one_liner": "Iron Santulan for deficiency triggered hair fall"
    },
    {
      "variantId": "47276517195954",
      "name": "For Stress",
      "one_liner": "Calm Ras to improve stress and sleep"
    },
    {
      "variantId": "47276531417266",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 2% that prevents hormone led hair damage"
    },
    {
      "variantId": "46465512898738",
      "name": "For Hair Regrowth",
      "one_liner": "Minoxidil 5% that prevents hormone led hair damage"
    },
    {
      "variantId": "44422009323698",
      "name": "For Hair Hygiene",
      "one_liner": "Defence Shampoo for pH balance (SLS Free)"
    },
    {
      "variantId": "47300731568306",
      "name": "For Hair Volume",
      "one_liner": "Serum with proven Hair Actives"
    },
    {
      "variantId": "47276511199410",
      "name": "For Digestion",
      "one_liner": "Consti Clear for improved digestion"
    },
    {
      "variantId": "47302757875890",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 01 for hair nourishment"
    },
    {
      "variantId": "47301161091250",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 02 for hair nourishment"
    },
    {
      "variantId": "46464896630962",
      "name": "For Stress, Metabolism & Digestion",
      "one_liner": "Hair Ras 05 for hair nourishment"
    },
    {
      "variantId": "47301139169458",
      "name": "For Stress & Metabolism",
      "one_liner": "Hair Ras 06 for hair nourishment"
    },
    {
      "variantId": "46464745308338",
      "name": "For Stress",
      "one_liner": "Hair Ras 09 for hair nourishment"
    }
  ];
  
  productData.forEach((each) => {
  const updated = updatedDataFromAPI.find(item => item.variantId === each.product_id);
  const caseProdId = response.User_Analysis.case_id;
  const displayName = updated ? updated.name : each.name;
  const productIdsArray = productData.map(p => p.product_id);
  const displayOneLiner = updated ? updated.one_liner : each.oneLiner;
     // ADD RIGHT AFTER caseProdId line:
  // const firstChar = String(caseProdId || '').charAt(0).toLowerCase();
  // const isVariation = ['c', 'd', 'e', 'f'].includes(firstChar);

  const tagsArray = each.tag.tagKeyArray;
  let tagsHTML = '';
  if (tagsArray.length > 1) {
    tagsHTML = tagsArray.map(tag => `<p class="tag-title">${tag}</p>`).join('');
  } else {
    tagsHTML = `<p class="tag-title">${tagsArray[0]}</p>`;
  }

  const productDiv = document.createElement('div');
  productDiv.classList.add('kit-card-container');
  productDiv.dataset.productId = each.product_id;
  productDiv.innerHTML = `
      <div class="kit-card">
          <div class="box-separator-line">
              <div class="product-imge">
                  <img src="${each.image_url.singleImage}" width="80" height="80" />
              </div>
              <div class="product-description">
                  <div class="prod-heading">
                      <p class="prod-title">${displayName}</p>
                      ${((each.type === 'Ayurveda' || each.type === 'ayurveda') && (caseProdId && /^[Def15679]/i.test(caseProdId)) && each.tag.customTag.showTag == false) 
                        ? `<p class="recommended-product--type d-none">
                          <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                            <path d="M1.24988 0.210509C1.26029 0.174453 1.27824 0.140656 1.30271 0.11105C1.32718 0.0814442 1.35769 0.0566105 1.3925 0.0379673C1.4273 0.0193241 1.46572 0.00723524 1.50555 0.0023961C1.54539 -0.00244303 1.58586 6.42699e-05 1.62465 0.00976677L1.62997 0.0111106C1.69925 0.0321174 2.33272 0.40002 3.25127 0.805552C4.42211 1.3223 5.97933 1.98564 6.58972 2.98936C7.51237 4.50645 7.20917 5.72395 5.69112 6.61242L6.31408 7.6368C6.33176 7.66429 6.34334 7.6948 6.34814 7.72651C6.35294 7.75822 6.35086 7.79051 6.34203 7.82147C6.3332 7.85242 6.31778 7.88143 6.2967 7.90677C6.27562 7.9321 6.2493 7.95327 6.21929 7.96901C6.18927 7.98475 6.15617 7.99474 6.12193 7.99842C6.08769 8.00209 6.05301 7.99936 6.01992 7.99039C5.98683 7.98141 5.95602 7.96638 5.92928 7.94617C5.90254 7.92596 5.88043 7.90098 5.86424 7.87271L5.24116 6.84832C3.63897 7.5985 2.36004 7.21184 1.43739 5.69474C0.3473 3.904 1.21228 0.36059 1.24988 0.210509ZM2.1515 5.42446C2.92413 6.69464 3.63062 6.98526 4.94968 6.36999L4.37037 5.41739L3.29793 5.27562C3.26386 5.27171 3.23096 5.26153 3.20117 5.24567C3.17137 5.22982 3.14527 5.20861 3.1244 5.18328C3.10352 5.15795 3.08829 5.12902 3.07959 5.09816C3.07088 5.0673 3.06887 5.03513 3.07369 5.00355C3.07851 4.97196 3.09006 4.94158 3.10765 4.91419C3.12524 4.88679 3.14853 4.86292 3.17616 4.84398C3.20379 4.82504 3.23519 4.81141 3.26856 4.80387C3.30192 4.79634 3.33656 4.79506 3.37046 4.8001L4.04927 4.88997L3.42245 3.8594C3.3915 3.80414 3.38487 3.73987 3.40395 3.68016C3.42303 3.62044 3.46633 3.56995 3.52471 3.53934C3.5831 3.50873 3.652 3.5004 3.71687 3.5161C3.78174 3.5318 3.83752 3.57031 3.87241 3.6235L5.39941 6.1342C5.84864 5.87044 6.33209 5.71058 6.5254 5.3765C6.86861 4.7828 6.64194 3.93949 6.14761 3.12663C5.58751 2.20548 4.04069 1.77613 2.91748 1.29556C2.42508 1.08471 2.03496 0.732419 1.75957 0.63772C1.67845 1.03325 1.28398 1.87274 1.23622 2.6865C1.17735 3.68405 1.70734 4.69462 2.15114 5.42446H2.1515Z" fill="#2D8A5D"/>
                          </svg>
                        <span>${each.type}</span>
                        </p>` 
                      : ``}
                  </div>
                  ${each.tag.customTag.showTag == true
                    ? `<div class="formulation-custom-tag">
                    MADE SPECIALLY FOR YOU
                    </div>`
                    : ''}
                  <div>
                      <p class="prod-details">${displayOneLiner}</p>
                  </div>
                  <div>
                      <p class="prod-price">
                        ₹${Math.floor(each.price)}
                      </p>
                  </div>
              </div>
              <div class="arrow">
                  <svg width="7" height="13" viewBox="0 0 7 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.53255 7.03063L1.53255 12.0306C1.39165 12.1715 1.20056 12.2507 1.0013 12.2507C0.802043 12.2507 0.610947 12.1715 0.470051 12.0306C0.329155 11.8897 0.25 11.6986 0.25 11.4994C0.25 11.3001 0.329155 11.109 0.470051 10.9681L4.93943 6.5L0.471301 2.03063C0.401536 1.96086 0.346196 1.87804 0.308439 1.78689C0.270683 1.69574 0.25125 1.59804 0.25125 1.49938C0.25125 1.40072 0.270683 1.30302 0.308439 1.21187C0.346196 1.12072 0.401536 1.03789 0.471301 0.968128C0.541066 0.898364 0.623889 0.843023 0.715041 0.805267C0.806193 0.76751 0.903889 0.748077 1.00255 0.748077C1.10121 0.748077 1.19891 0.76751 1.29006 0.805267C1.38121 0.843023 1.46404 0.898364 1.5338 0.968128L6.5338 5.96813C6.60364 6.03789 6.65902 6.12075 6.69677 6.21196C6.73451 6.30316 6.75388 6.40093 6.75377 6.49964C6.75365 6.59835 6.73405 6.69606 6.69609 6.78718C6.65813 6.8783 6.60255 6.96103 6.53255 7.03063Z" fill="black"></path>
                  </svg>
              </div>
          </div>
          <hr class="block-line-separator d-none">
          <div class="tags tag-container d-none">
              <img src="${each.tag.icon}" alt="${each.tag.title}" class="d-none tag-icon">
              ${tagsHTML}
          </div>
      </div>
  `;
  newSection.appendChild(productDiv);

  // Add to cart logic
  if (getCookie("GuestForm_id")) {
    variantsIDs.push({
      'id': each.product_id,
      'quantity': 1,
      properties: {
        '_result_id': id
      }
    });
  } else {
    variantsIDs.push({
      'id': each.product_id,
      'quantity': 1
    });
  }
});

  containerDiv.appendChild(newSection);
  const firstSection = document.querySelectorAll('.hair_thinning_kit-container');
  if (firstSection && firstSection.parentNode) {
    firstSection.parentNode.insertBefore(containerDiv, firstSection.nextSibling);
  }
  addClickEventListernerToMonthkit(productIdsArray);

}

// functionality for real stories
function sectionRealStories(response) {
  let { successStories } = response;
  if (successStories.showComponent == true) {
    const imgCarousel = document.querySelector('.image-carousel');
    const titleElement = document.querySelector('.stories-main-heading');
    const subTitleElement = document.querySelector('.stories-sub-heading');
    titleElement.textContent = successStories.title;
    subTitleElement.textContent = successStories.subTitle;

    successStories.stories.forEach((storyUrl) => {
      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl.imageUrl}" alt="Success Story" height="auto" width="auto">
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true, 
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            dots: true,
          },
        },
      ],
    });
  }
}

// doctor recomandation section 
function sectionBlocksDisplay(response) {
  let { stage_transition } = response;
  let stage = stage_transition.currentStage.stage;
  const apiSection = document.querySelector('.static-block-container');
  const staticSection = document.querySelector('.block-container');

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  if (stage === 'Stage-1') {
    apiSection.style.display = 'none';
    staticSection.style.display = isDesktop ? 'flex' : 'block';
  } else {
    apiSection.style.display = isDesktop ? 'flex' : 'block';
    staticSection.style.display = 'none';
  }
}
// doctor recomandation section end

// custom price 
function customPriceSection(response) {
  let cartPrice = response.cart_price;
  cartPrice = parseFloat(cartPrice).toFixed(2);
    if (cartPrice.endsWith('.00')) {
      cartPrice = parseInt(cartPrice);
    }

  let slashPrice = cartPrice + 500;

  const dynamicPriceElements = document.querySelectorAll('#dynamic-price');
  if (dynamicPriceElements.length > 0) {
    dynamicPriceElements.forEach(element => {
      element.innerHTML = cartPrice;
    });
  } else {
    console.error('Price elements not found');
  }

  const slashPriceElement = document.getElementById('slash-price');
  if (slashPriceElement) {
    slashPriceElement.innerHTML = `₹${slashPrice}`;
  } else {
    console.error('Slash price element not found');
  }
}
// end of custom price

// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');
    const weeksUpdateElement = document.querySelector('.weeks-update');
    const timelineHeadingUpdate = document.querySelector('.timeline-heading');
    weeksUpdateElement.innerHTML = monthsExpectation.months;

    // "Kit" title + new_goal for ALL case ids
    if (timelineHeadingUpdate) {
      timelineHeadingUpdate.innerHTML = `Start Seeing Results In <span style="color: #329866;" class="weeks-update">${monthsExpectation.months}</span> Kits`;
    }

    monthsExpectation.monthExpectations.forEach((month, index) => {
      const titleText = `Kit ${month.month}`;
      const goalText  = month.new_goal || month.goal;

      const block = document.createElement('div');
      block.className = 'timeline-block';
      block.innerHTML = `
          <div class="timeline-icon">
            <img src="${month.image_url}" alt="Kit ${month.month}" width="100" height="100">
          </div>
          ${index < monthsExpectation.monthExpectations.length - 0 ? `
            <div class="timeline-dot-line">
              <div class="timeline-dot"></div>
              <div class="timeline-line"></div>
            </div>
          ` : ''}
          <div class="timeline-content">
            <p><strong>${titleText}</strong></p>
            <p style="max-width:85%; margin:0 auto;">${goalText}</p>
          </div>
      `;
      timeline.appendChild(block);
    });

    if (window.innerWidth > 767) {
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              centerMode: true,
              centerPadding: "15px",
            },
          },
        ],
      });
    }
  }
}

function applyFootnoteMarkers(caseId, notes) {
  var markers = ['*', '+', 'o'];
  notes.forEach(function(el, i) {
    if (i < markers.length) {
      var text = el.textContent.replace(/^\*+/, '');
      var m = markers[i];
      var mStyle = m === '*' ? 'vertical-align:-0.1em;font-size:1em;' : 'vertical-align:0.4em;font-size:0.7em;';
      el.innerHTML = '<span style="font-weight:700;' + mStyle + '">' + m + '</span>' + text;
    }
  });
}
function successRateDataFetch(data) {
  const trigger = document.querySelector('.results-ui-update');
  const cliniclStudyNote = document.querySelectorAll('.clinical-study-note');
  const popup = document.getElementById('successrate-popup');
  const closeBtn = popup?.querySelector('.successrate-close');
  const contentBox = document.getElementById(
    'successrate--popup-content-placeholder'
  );
  const normalResultProgress = document.querySelector('.cstm-growthPossibilityBar.progress')
  const geneticAnswer = data?.Recommendations?.Genetic;
  const stage = data?.currentStage?.stage;
  const allowedStages = ["Stage-1", "Stage-2", "Stage-3", "Stage-4"];
  // if (caseId && !/^[0-7]/.test(caseId) && allowedStages.includes(stage)) {
    trigger?.classList.remove('d-none');
    cliniclStudyNote.forEach(el => { el.classList.remove('d-none'); el.classList.remove('d-md-none'); });
    applyFootnoteMarkers(data?.User_Analysis?.case_id, cliniclStudyNote);
    normalResultProgress?.classList.add('d-md-block')
  // } else {
  //   normalResultProgress?.classList.remove('d-none')
  //   normalResultProgress?.classList.remove('d-md-block')
  // }
  if (!trigger || !popup || !contentBox || !closeBtn) return;

  let cachedHTML = '';
  let isReady = false;

  // 1️⃣ PREFETCH ON PAGE LOAD
  async function prefetchSuccessRatePage() {
    try {
      const res = await fetch('/pages/93-success-rate');
      if (!res.ok) throw new Error('Fetch failed');

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const pageContent =
        doc.querySelector('.page-width') ||
        doc.querySelector('main') ||
        doc.body;

      cachedHTML = pageContent.innerHTML;
      contentBox.innerHTML = cachedHTML;
      isReady = true;

      console.log('✅ Success rate page prefetched');
    } catch (err) {
      console.error('Prefetch failed:', err);
      contentBox.innerHTML =
        '<p>Unable to load content. Please refresh.</p>';
    }
  }

  // 2️⃣ OPEN POPUP (NO FETCH HERE)
  function openPopup() {
    if (!isReady) return; // safety
    popup.classList.add('show');
    document.body.style.overflow = 'hidden';
  }

  // 3️⃣ CLOSE POPUP
  function closePopup() {
    popup.classList.remove('show');
    document.body.style.overflow = '';
  }

  // Bind events
  trigger.addEventListener('click', openPopup);
  closeBtn.addEventListener('click', closePopup);

  popup.addEventListener('click', function (e) {
    if (e.target === popup) {
      closePopup();
    }
  });

  // 🔥 IMPORTANT: prefetch immediately
  prefetchSuccessRatePage();
}

function rootCause (response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];
  let primaryRootCauseHtml = '';
  let primaryRootCauseContentHtml = '';
  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" width="auto" height="auto"/>
        </div>
        <div class="primary-tag-flex">
          <p class="mt-2">${primaryRootCause[0]?.title}</p>
          <p class="primary-tag d-none">Primary</p>
        </div>
      </a>
    </li>`;
  }
  if (primaryRootCause.length > 0) {
    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }
  const defaultRootCauseHtml = defaultRootCause.map((item) => {
    return `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
        <div class="rootCauseLinkImg">
          <img src="${item?.details?.icon}" width="auto" height="auto"/>
        </div>
        <div class="primary-tag-flex">
          <p class="mt-2">${item?.title}</p>
          <p class="primary-tag d-none">Primary</p>
        </div>
      </a>
    </li>`;
  }).join('');
  const defaultRootCauseContentHtml = defaultRootCause.map((item) => {
    return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${item?.details?.description?.english}</p></div>`;
  }).join('');
  const rootCauseHtml = `<ul class="nav rootCause-nav-tabs border-0" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>
  <div class="tab-content rootCauseTabContent p-2 p-md-3 mt-3" id="myTabContent">${primaryRootCauseContentHtml}${defaultRootCauseContentHtml}</div>`;
  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
    const urlParams = new URLSearchParams(window.location.search);
    const rootcauseFromURL = urlParams.get("rootcause");
    const primaryTitle = primaryRootCause?.[0]?.title.toLowerCase();
    const primaryTagEl = rootCauseSectionWrapper.querySelector(".primary-tag");
    console.log(rootcauseFromURL, 'rootcauseFromURL', primaryTitle, 'primaryTitle')
    if (rootcauseFromURL && primaryTitle && rootcauseFromURL === primaryTitle) {
      primaryTagEl?.classList.remove("d-none");
    } else {
      primaryTagEl?.classList.add("d-none");
    }
  }
}

// functionality for customer result male
function displayStageSection(response) {
  const stageImages = {
    "Stage-1": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage-1-img1.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img2.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img3.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stgae1-img4.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img5.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img6.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img7.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img8.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img9.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img10.webp?v=1749470793",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage1-img11.webp?v=1749470793"
      ],
      customerName: "Prashant"
    },
    "Stage-2": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-1.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-2.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-3.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-4.webp?v=1749473384",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-5.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-6.webp?v=1749473383",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage2-Image-7.webp?v=1749473383"
      ],
      customerName: "Abhishek"
    },
    "Stage-3": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image.webp?v=1749474168",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-1.webp?v=1749474168",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-2.webp?v=1749474169",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-3.webp?v=1749474168",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-4.webp?v=1749474169",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage3-Image-5.webp?v=1749474168"
      ],
      customerName: "Vaibhav"
    },
    "Stage-4": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-1.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-2.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-3.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-4.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-5.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-6.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-7.webp?v=1749474703",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-8.webp?v=1749474704",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage4-Image-9.webp?v=1749474705"
      ],
      customerName: "Prem"
    },
    "Stage-5": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-1.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-2.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-image-3.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-4.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-5.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-image-6.webp?v=1749475547",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/stage5-Image-7.webp?v=1749475547"
        
      ],
      customerName: "Anand"
    },
    "Heavy Hair Fall": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/heavy-hair-fall-Image.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-1.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-2.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-3.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-4.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-5.png?v=1749476010",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-6.png?v=1749476011",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Heavy-hair-fall-Image-7.png?v=1749476010"
      ],
      customerName: "Gopal"
    },
    "Coin Size Patch": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-1.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-2.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-3.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-4.webp?v=1749476276",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/coin-size-Image-5.webp?v=1749476276"
      ],
      customerName: "Darshit"
    }
  };

  const userStage = response.User_Analysis.stage;
  const stageData = stageImages[userStage];
  console.log("User stage from response:", userStage);

  const stageContainer = document.getElementById("stageContainer");
  stageContainer.innerHTML = ""; 
  
  if (stageData && stageData.images.length > 0) {
    const p1 = document.createElement("p");
    p1.textContent = `Here is ${stageData.customerName}`;
    p1.className = "custome-stage-heading";
    stageContainer.appendChild(p1);

    const p2 = document.createElement("p");
    p2.textContent = "Who Matches Your Profile";
    p2.className = "custome-stage-subheading";
    stageContainer.appendChild(p2);

    const imageWrapper = document.createElement("div");
    imageWrapper.className = "stage-image-wrapper";

    stageData.images.forEach((imgUrl) => {
      const img = document.createElement("img");
      img.src = imgUrl;
      img.alt = userStage;
      img.className = "scrollable-stage-image"; 
      img.loading = "lazy"; 
      imageWrapper.appendChild(img);
    });

    stageContainer.appendChild(imageWrapper);
  }
}

function displayProduct(response) {
  var resp = Object.assign(response.User_Analysis, response.Recommendations);
  f_name = resp.first_name;
  C_number = resp.phone;
  C_email = resp.email;
  user__gender = resp.gender;
  setCookie('user_phone', C_number, 30);
  caseId= resp.case_id;
  localStorage.setItem('caseId', caseId);
  var gmpNote = document.querySelector('.gmp-certified-strip');
  if (gmpNote) gmpNote.classList.remove('d-none');
  var stickyBtn = document.getElementById('sticky-btn');
  if (stickyBtn) stickyBtn.style.boxShadow = 'none';
  if(user__gender == 'M') {
    user_gender = 'Male';
  }
  var coin_size = false;
  if(resp.stage == 'Coin Size Patch') {
    coin_size = true;
  }
  var productTemplate = 'result-product-list', slides = 1, mobileSlides = 1 ,arrows = false, dots = true;
  if(resp.stage == "Stage-1") {
    productTemplate = 'result4c-card', slides = 3, mobileSlides = 1.3;
  }else {
    productTemplate = 'result4c-card', slides = 3, mobileSlides = 1.3;
    // productTemplate = 'result-product-list', slides = 1, mobileSlides = 1;
  }
  var test_result = document.querySelectorAll('.test-result'), sticky_btn = document.querySelectorAll('.sticky-btn'), 
  transplant_stage_six = document.querySelectorAll('.transplant-stage-six'), normal_page_is = true;
  var  stageDescription_text = document.querySelectorAll('.stageDescription_text'),
  user_type_stage = document.querySelectorAll('.user_type_stage'), diagnosed_text = document.querySelectorAll('.diagnosed_text'),
  productKitSection = document.querySelectorAll('.kit-container'), doctorsSection = document.querySelectorAll('.section-coach.container'),
  timelineSection = document.querySelectorAll('.timeline--container'), priceBreakStage = document.querySelectorAll('.custom-price-section'),
  eligibilityCheck = document.querySelectorAll('.eligibility-check--section'), faqSection = document.querySelectorAll('.aldrich-faq');
  if(resp.gender == 'M' && resp.stage == "Stage-6"){
    document.querySelector('body.result4').style.width = '100%';
    document.querySelector('body.result4 #MainContent').style.padding = 0;
    normal_page_is = false;
  }else{
    normal_page_is = true;
  }
  if(test_result.length != 0) {
    test_result.forEach((result) => {
      if(normal_page_is == false) {
        result.classList.add('d-none');
      }else {
        result.classList.remove('d-none');
      }
    })
  }
  if(productKitSection.length != 0) {
    productKitSection.forEach((kit) => {
      if(normal_page_is == false) {
        kit.classList.add('d-none');
        const futureKitSection = document.querySelector('.future-kit-routine');
        if(futureKitSection) futureKitSection.style.display = 'none';
      }else {
        kit.classList.remove('d-none');
      }
    })
  }
  if(doctorsSection.length != 0) {
    doctorsSection.forEach((doctors) => {
      if(normal_page_is == false) {
        doctors.classList.add('d-none');
      }else {
        doctors.classList.remove('d-none');
      }
    })
  }
  if(timelineSection.length != 0) {
    timelineSection.forEach((time) => {
      if(normal_page_is == false) {
        time.classList.add('d-none');
      }else {
        time.classList.remove('d-none');
      }
    })
  }
  if(priceBreakStage.length != 0) {
    priceBreakStage.forEach((priceBreak) => {
      if(normal_page_is == false) {
        priceBreak.classList.add('d-none');
      }else {
        priceBreak.classList.remove('d-none');
      }
    })
  }
  if(eligibilityCheck.length != 0) {
    eligibilityCheck.forEach((check) => {
      if(normal_page_is == false) {
        check.classList.add('d-none');
      }else {
        check.classList.remove('d-none');
      }
    })
  }
  if(faqSection.length != 0) {
    faqSection.forEach((faq) => {
      if(normal_page_is == false) {
        faq.classList.add('d-none');
      }else {
        faq.classList.remove('d-none');
      }
    })
  }
  if(sticky_btn.length != 0) {
    sticky_btn.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.add('d-none');
      }else {
        section.classList.remove('d-none');
      }
    });
  }
  if(transplant_stage_six.length != 0) {
    transplant_stage_six.forEach((section) => {
      if(normal_page_is == false) {
        section.classList.remove('d-none');
      }else {
        section.remove();
      }
    });
  }
    
  // Recommended Products End
  if (resp.stage == "Stage-1") {
    document.querySelector('#stage').innerHTML = 'Stage 1 Of ';
  }else if (resp.stage == "Stage-2") {
    document.querySelector('#stage').innerHTML = 'Stage 2 Of ';
  }else if(resp.stage == "Stage-3"){
    document.querySelector('#stage').innerHTML = 'Stage 3 Of ';
  }else if(resp.stage == "Stage-4"){
    document.querySelector('#stage').innerHTML = 'Stage 4 Of ';
  }else if(resp.stage == "Stage-5"){
    document.querySelector('#stage').innerHTML = 'Stage 5 Of ';
  }
  if (trayaProcessingAnimation) {
    trayaProcessingAnimation.style.display = 'none';
  }
  document.body.style.overflow = 'unset';
}

function getProductByHandle(response) {
  let femaleResultBuyBtn = document.querySelectorAll('#add-to-cart-result-page');
  let resultTotalPrice = document.querySelectorAll('.total-price');
  let strikeTotalPrice = document.querySelectorAll('.strike-cart-total-price');
  let sticky_slash_price_element = document.getElementById('sticky-slash-price');
  // const finalCartPrice = Math.round(response.cart_price);
  // const strikeFinalCartPrice = Math.round(response.newPriceCard.updatedCartPrice);
  // const firstChar = String(response?.User_Analysis?.case_id || '').charAt(0).toLowerCase();
  //  const isVariation = ['c', 'd', 'e', 'f'].includes(firstChar);

// const finalCartPrice = Math.round(response.cart_price);
// const strikeFinalCartPrice = isVariation
//   ? finalCartPrice + 500
//   : Math.round(response.newPriceCard.updatedCartPrice);



//  const _saveFirstChar = String(response?.User_Analysis?.case_id || '').charAt(0).toLowerCase();
//   const _saveEligible = new Set(['0','1','2','3','4','5','6','7']).has(_saveFirstChar);
// 700 "you save" for all case IDs (100%) — no cohort gating.
  const saveAmount = 700;

  const finalCartPrice = Math.round(response.cart_price);
  const strikeFinalCartPrice = finalCartPrice + saveAmount;


  if (strikeTotalPrice.length !== 0) {
    strikeTotalPrice.forEach((price) => {
      price.innerHTML = `₹${strikeFinalCartPrice}`;
    });
  }
  if (resultTotalPrice.length !== 0) {
    resultTotalPrice.forEach((price) => {
      price.innerHTML = `₹${finalCartPrice}`;
    });
  }  
 if (sticky_slash_price_element) {
    // Sticky footer strikeout uses the same variation-aware save amount (700/500).
    sticky_slash_price_element.innerHTML = `₹${finalCartPrice + saveAmount}`;
  }

  if(femaleResultBuyBtn.length != 0) {
    femaleResultBuyBtn.forEach((buyBtn) => {
      buyBtn.setAttribute('data-price', prices);
    })
  }
  const productData = response.product_Ids;
  const defaultRootCause = response.root_causes.defaultRootCause || [];
  const primaryRootCause = response.root_causes.primaryRootCause || [];
  const includedIds = new Set(["47329496826034", "46528906821810", "46528923304114", "47303072710834", "46530365751474"]);
  const userStage = response.User_Analysis.stage;
  const allRootCauses = [...defaultRootCause, ...primaryRootCause];
  const rootCauseTitles = new Set(
    allRootCauses.map(rc => rc.title.toLowerCase())
  );
  const requiredRootCauses = ['dandruff', 'metabolism', 'nutrition'];
  const hasAllRequiredRootCauses = requiredRootCauses.every(
    required => rootCauseTitles.has(required)
  );
  if (userStage === 'Stage-2' && hasAllRequiredRootCauses) {
    const existingVariantIds = new Set(
      productData.map(p => String(p.product_id))
    );
    const hasAllProducts = [...includedIds].every(id => existingVariantIds.has(id));
    if (hasAllProducts) {
      document.querySelector('.male-result-video--section').classList.remove('d-none');
    }
  }
  const dietCaseId = String(response?.User_Analysis?.case_id).trim();
  applyOneMonthDiscount(response);
}

function applyOneMonthDiscount(response) {
  const discountsData = response?.discounts;
  if (!discountsData) return;

  if (!discountsData.discountValidityByPlan?._1Month) return;
  const discountObj = discountsData.discount?.[0];
  if (!discountObj) return;

  const { code, value, validCartValue } = discountObj;
  if (!code || !value || !validCartValue) return;

  const cartTotal = Math.round(response.cart_price);
  if (cartTotal < validCartValue) return;
  
  let discountAmount = 0;

  if (discountObj.type === 'percentage') {
    discountAmount = Math.round((cartTotal * value) / 100);
  } else {
    // default = flat value
    discountAmount = value;
  }

  const discountedTotal = Math.max(cartTotal - discountAmount, 0);
   // ── "You Save" amount variation (post-discount strikeout) ────────────────
  // Mirror the getProductByHandle logic so the strikeout stays consistent after
  // a discount is applied: eligible case IDs (8,9,a,b,c,d,e,f) → +700, else +500.
  // const _saveFirstChar = String(response?.User_Analysis?.case_id || '').charAt(0).toLowerCase();
  // const _saveEligible = new Set(['0', '1', '2', '3', '4', '5', '6', '7']).has(_saveFirstChar);
  // const strikeoutPriceAfterDiscount = discountedTotal + (_saveEligible ? 700 : 500);
  const strikeoutPriceAfterDiscount = discountedTotal + 700;


  // const strikeoutPriceAfterDiscount = discountedTotal + 500;
  // UI price updates
  document.querySelectorAll('.strike-cart-total-price').forEach(el => {
    el.innerHTML = `₹${strikeoutPriceAfterDiscount}`;
  });

  document.querySelectorAll('.total-price').forEach(el => {
    el.innerHTML = `₹${discountedTotal}`;
  });

  const stickySlash = document.getElementById('sticky-slash-price');
  if (stickySlash) {
    stickySlash.innerHTML = `₹${strikeoutPriceAfterDiscount}`;
  }

  // Show referral applied UI
  document.querySelectorAll('.refferal-discount-applied').forEach(el => {
    el.classList.remove('d-none');
  });

  // ✅ ONLY store the code
  window.appliedReferralCode = code;
}

function updateCartDrawer() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(item => {
        if (item.quantity === 2) {
          updates[item.key] = 1; 
        }
      });

      if (Object.keys(updates).length > 0) {
        const body = {
          updates: updates
        };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })
        .then(res => res.json())
        .then(() => {
          refreshCartUI();
        })
        .catch(err => console.error('Error updating quantities:', err));
      } else {
        refreshCartUI();
      }
    });
}
function bindCartDrawerEvents() {
  const closeBtn = document.querySelector('.drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.querySelector('cart-drawer.drawer')?.classList.remove('active');
      document.querySelector('.cart-drawer__overlay')?.classList.remove('active');
    });
  }
}
function refreshCartUI() {
  // Update cart bubble
  fetch('/?sections=cart-icon-bubble')
  .then(res => res.json())
  .then(data => {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && data['cart-icon-bubble']) {
      cartIconBubble.innerHTML = data['cart-icon-bubble'];
    }
  });

  // Update cart drawer section
  fetch('/?sections=cart-drawer')
  .then(res => res.json())
  .then(data => {
    const cartDrawerHTML = data['cart-drawer'];
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawerHTML) {
      cartDrawer.outerHTML = cartDrawerHTML;
      setTimeout(() => {
        bindCartDrawerEvents?.();
      }, 50);

      document.querySelectorAll('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity').forEach(el => {
        el.style.display = 'none';
      });
    }
  })
  .catch(err => console.error('Error updating cart drawer:', err));
}

function checkout() {
  localStorage.setItem('user__gender',user_gender);
  localStorage.setItem('caseId',caseId);
  if(user__gender == 'M') {
    user_gender = 'Male';
  }
  variantsIDs.forEach((e) => {
    if(e.id === 37681124081842){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 42648509186226){
      e.properties = {'Plan': 'Dandruff'};
    }else if(e.id === 41899898011826){
      e.properties = {'Plan': 'Dandruff'};
    }else {
      e.properties = {'Plan': 'Auto'};
    }
  });
  let formData = {
    'items': variantsIDs,
    sections: 'cart-drawer',
    attributes: {
      first_name: f_name,
      phone: C_number,
      email: C_email,
      caseid: caseId,
      user__gender: user_gender,
      syntheticId: window.location.search.substring(1).split('=')[1] || "default-id"
    }
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {  
    localStorage.setItem('User_location', "cart");
    return response.json();
  }).then(result => { 
    var t = document.querySelector('cart-drawer');
    let cart_drawer = result.sections['cart-drawer'];
    CartDrawerUpdate(t, cart_drawer);
  }).catch((error) => {
    console.error('Error:', error);
  }).finally(() => {
    updateCartDrawer();
    cartData();
    var atcButton2 = document.querySelector('#add-to-cart-result-page');
    // atcButton2.classList.remove('loader-added')
    atcButton2.disabled = false;
  });
}

async function fireEvent(eventName, caseID, attributes = {}) {
  const MoEngageAPI = {
    DEV: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };

  // These are always sent, your custom attributes get merged in
  const defaultAttributes = {
    platform: "web_shopify",
    domain: "traya.health",
    URL: window.location.href,
    syntheticId: new URLSearchParams(window.location.search).get('id') || "default-id"
  };

  const response = await fetch(`${MoEngageAPI.PROD}eventMoengageWeb`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    },
    body: JSON.stringify({
      eventName,
      eventAttributes: {
        generalAttributes: {
          ...defaultAttributes,  // always included
          ...attributes          // your custom ones, also overrides defaults if needed
        }
      },
      caseId: caseID
    })
  });
}

function initHairAIPopup(){
  const images = document.querySelectorAll(".stage-hair-ai-image img");
  const popup = document.getElementById("hairAiPopup");
  const popupImage = document.getElementById("popupHairImage");
  if(!images.length || !popup) return;
  images.forEach((img)=>{
    img.addEventListener("click", function(){
      popup.classList.add("active");
       popupImage.src = this.src;            // ← V1 giveaway: just sets src
      fireEvent("image_click", caseId, {
        syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
        language: "english"
      });
    });
  });
  // Close popup when overlay is clicked
  popup.addEventListener("click", function(e){
    if(e.target === popup){
      popup.classList.remove("active");
    }
  });
}

function ShowContent(response) {
  var data = Object.assign(response.User_Analysis, response.Recommendations);
  let stageDescription = response.stageWiseDescription.english;
  var growthPossibility = response.growthPossibilityBar;
  var maxMonth = response.Recommendations.Max_months;
  var grothBar = document.querySelector(".cstm-growthPossibilityBar")
  var treatedCount = response.treatedCXCount.description;
  var treatedCountDOM = document.querySelector(".customer-based-profile");
  var treatmentDuration = document.querySelector(".traetment-duration");
  treatmentDuration.innerText = `${maxMonth} Months`
  FutureKitRoutine(maxMonth);
  if (treatedCountDOM) treatedCountDOM.innerText = treatedCount;
  var illness = data.experienced_in_one_year, genetics = data.Genetic, userStage = data.stage;
  var userName = document.querySelectorAll('[data-user-name]'), name1 = document.querySelectorAll('#name1'),
  name3 = document.querySelectorAll('#name3'), stage1 = document.querySelectorAll('#stage1'),
  typeOfLoss3 = document.querySelectorAll('#typeOfLoss3'), stage3 = document.querySelectorAll('#stage3'),
  stageDescriptionMain = document.querySelectorAll('#stageDescription'), stage3 = document.querySelectorAll('#stage3'),
  typeOfLoss = document.querySelectorAll('#typeOfLoss'), mainstage = document.querySelectorAll('#stage');
  var ourdia = document.querySelector('#ourdia'), stagesnames = document.querySelectorAll('.stages-name');
  var stageImage = response?.currentStage?.imgUrl;
  if(growthPossibility == true){grothBar.style.display = "block";}
  if(userName.length != 0) { userName.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(name1.length != 0) { name1.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(name3.length != 0) { name3.forEach((name) => { name.innerHTML = `${data.first_name}` }) }
  if(stage1.length != 0) { stage1.forEach((stage) => { stage.innerHTML = `${data.stage?.replace(/-/g, ' ')}` }) }
  if(typeOfLoss3.length != 0) { typeOfLoss3.forEach((loss) => { loss.innerHTML = `${data.Type_of_hair_loss}` }) }
  if(typeOfLoss.length != 0) { 
    if(data.stage == 'Coin Size Patch' || data.stage == 'Heavy Hair Fall'){
      typeOfLoss.forEach((loss) => { loss.innerHTML = `${data.stage}` })
    } else {
       typeOfLoss.forEach((loss) => { loss.innerHTML = `${data.Type_of_hair_loss}` })
    }
  }
  if(stage3.length != 0) { stage3.forEach((stage) => { stage.innerHTML = `${data.stage?.replace(/-/g, ' ')}` }) }
  if(stageDescriptionMain.length != 0) { 
    stageDescriptionMain.forEach((stage) => { 
      if(userStage == 'Heavy Hair Fall'){
        stage.innerHTML = `Heavy hair fall is caused when your body has been through a major shock. This type of hair fall is completely reversible and we're confident you'll see results within 3-6 months.`; 
      } else {
        stage.innerHTML = `${stageDescription}`; 
      }
    })
  }
  if(illness.length != 0) {
    var TECondition = illness.filter((ill) => {
      if(ill == 'Severe Illness (Dengue, Malaria, Typhoid or Covid)') {
        return ill;
      }
    })
  }
  /* Dandruff Response */
  var dandruffResp = response.User_Analysis.dandruff_response;
  
  if(userStage != 'Stage-6') {
    if(dandruffResp == 'Yes, heavy dandruff that sticks to the scalp') {
      let stageElement = document.querySelector('.male_pcos_causing_main');
      if(stageElement){
        document.querySelector('.male_pcos_causing_main').style.display = 'block';
      }
    }
  }

  if(userStage == 'Stage-6') {
      let stage6plan = document.querySelector('.male-treatment-plan');
      let stage6plan2 = document.querySelector('.aldrich-faq');
      if(stage6plan && stage6plan2){
        document.querySelector('.male-treatment-plan').style.display = 'none';
        document.querySelector('.aldrich-faq').style.display = 'none';
      }
    }
  
  if(userStage != 'Stage-6') {
    let userStage6plan = document.querySelector('.stage1-doctors');
    if(userStage6plan){
      document.querySelector('.stage1-doctors').style.display = 'block';
    }
  }

  
const params = new URLSearchParams(window.location.search);
  const urlSource = params.get("url_source");
  var FrontAPIImage = response?.currentStage?.frontImageURL;
  var topAPIImage = response?.currentStage?.topImageURL;
  var frontTopImagesContainer = document.querySelector(".front-top-images-container");

  // ─────────────────────────────────────────────────────────────
  // ❌ COMMENTED OUT: questionsV5_FC branch — was duplicating the
  // same Hair AI logic as the else branch below. Single block
  // below now handles all url_sources.
  // ─────────────────────────────────────────────────────────────
  /*
  if (urlSource === "questionsV5_FC") {

    const hasFrontTop = frontTopImagesContainer && topAPIImage && FrontAPIImage;

    if (hasFrontTop) {
      let frontTopImages = document.querySelector(".front-top-images-container");
      frontTopImages.classList.remove('d-none');

      let resultSelectedStage = document.querySelector(".selectedStage");
      resultSelectedStage.classList.add('d-none');

      let frontImage = frontTopImagesContainer.querySelector("img.frontstage-image");
      let topImage = frontTopImagesContainer.querySelector("img.topstage-image");

      if (topAPIImage) topImage.setAttribute("src", topAPIImage);
      if (FrontAPIImage) frontImage.setAttribute("src", FrontAPIImage);

    } else {

      var __selectedStage = document.querySelectorAll(".selectedStage");
      if (__selectedStage.length) {
        __selectedStage.forEach((stage) => {
          var imageField = stage.querySelector("img");
          let hairLineAiImage = document.querySelector('.stage-hair-ai-image img');

          if (response?.hairAIData?.image_b64 && hairLineAiImage) {
            hairLineAiImage.classList.remove('d-none');
            hairLineAiImage.src = `data:image/jpeg;base64,${response.hairAIData.image_b64}`;
            hairLineAiImage.dataset.stageImage = imageField.src;
            initHairAIPopup();

            const _currentCaseId = String(response?.User_Analysis?.case_id || '').trim();
            if (_currentCaseId && /^[0234]/i.test(_currentCaseId)) {
              initBothImagesComparison(response, imageField.src);
            }
          } else if (stageImage) {
            stage.classList.remove('d-none');
            imageField.src = stageImage;
          }
        });
      }
    }

  } else {
  */
  // ─────────────────────────────────────────────────────────────
  // ✅ ACTIVE: Single block (formerly the else branch) — handles
  // both questionsV5_FC AND all other url_sources identically.
  // ─────────────────────────────────────────────────────────────

  const hasFrontTop = frontTopImagesContainer && topAPIImage && FrontAPIImage;

  if (hasFrontTop) {
    let frontTopImages = document.querySelector(".front-top-images-container");
    frontTopImages.classList.remove('d-none');

    document.querySelectorAll(".selectedStage").forEach(el => el.classList.add('d-none'));

    let frontImage = frontTopImagesContainer.querySelector("img.frontstage-image");
    let topImage = frontTopImagesContainer.querySelector("img.topstage-image");

    if (topAPIImage) topImage.setAttribute("src", topAPIImage);
    if (FrontAPIImage) frontImage.setAttribute("src", FrontAPIImage);

  } else {

    var __selectedStage = document.querySelectorAll(".selectedStage");

   if (__selectedStage.length) {
      __selectedStage.forEach((stage) => {
        var imageField = stage.querySelector("img");
        let hairLineAiImage = document.querySelector('.stage-hair-ai-image img');

        if (response?.hairAIData?.image_b64 && hairLineAiImage) {
          hairLineAiImage.classList.remove('d-none');
          hairLineAiImage.src = `data:image/jpeg;base64,${response.hairAIData.image_b64}`;
          // ← store the stage image so the popup slider can use it as the bottom layer
          hairLineAiImage.dataset.stageImage = imageField.src;
          initHairAIPopup();

          // // ── Show BOTH images side-by-side for case IDs starting with 0, 2, 3, or 4 ──
          // const _currentCaseId = String(response?.User_Analysis?.case_id || '').trim();
          // if (_currentCaseId && /^[01234567]/i.test(_currentCaseId)) {
          //   initBothImagesComparison(response, imageField.src);
          // }
        } else if (stageImage) {
          stage.classList.remove('d-none');
          imageField.src = stageImage;
        }
      });
    }
  }
  var diagnoses__image =  document.querySelector('.diagnoses-result > img');
  if(diagnoses__image) { diagnoses__image.style.display = 'none'; }
  if(ourdia) {
    var ourdia__li = ourdia.querySelectorAll('li');
    ourdia__li.forEach((li) => {
      li.style.display = 'none';
    });
    var ourdia__btns = ourdia.querySelectorAll('a');
    if(ourdia__btns.length != 0) {
      ourdia__btns.forEach((btns) => {
        btns.addEventListener('click', function(e) {
          e.preventDefault();
          var id = this.getAttribute('data-id'), tab_panes = document.querySelectorAll('.tab-pane'),
          nav__links = document.querySelectorAll('.nav-item.nav-link');
          tab_panes.forEach((pane) => {
            pane.classList.remove('active');
            pane.classList.remove('show');
          });
          document.querySelector(`#nav-tabContent #${id}`).classList.add('active');
          document.querySelector(`#nav-tabContent #${id}`).classList.add('show');
          nav__links.forEach((links) => {
            links.classList.remove('active');
          });
          document.querySelector(`#nav-tab #${id}-tab`).classList.add('active');
        });
      });
    }
  }
  if(stagesnames.length) {showOrHide(stagesnames, "none");}
  var __selectedStage = document.querySelectorAll(".selectedStage");
  if(__selectedStage.length) {
    __selectedStage.forEach((stage) => {
      var imageField = stage.querySelector("img");
      if(imageField && stageImage) imageField.setAttribute("src", stageImage);
    })
  }
  var atcButtonRP4 = document.querySelectorAll('#add-to-cart-result-page'),
  stickyAtcButtonRP4 =  document.querySelectorAll('.sticky-btn #add-to-cart-result-page');
  if(atcButtonRP4.length != 0) {
    atcButtonRP4.forEach((btn) => {
      btn.setAttribute('user-mobile', data.phone);
      btn.setAttribute('user-email', data.email);
    });
  }
  if(stickyAtcButtonRP4.length != 0) {
    stickyAtcButtonRP4.forEach((btn) => {
      btn.setAttribute('user-mobile', data.phone);
      btn.setAttribute('user-email', data.email);
    });
  }
  // buy now click cpi event
  let buyButtonElements = document.querySelectorAll('#add-to-cart-result-page');
  buyButtonElements.forEach((eachBtn) => {
      eachBtn.addEventListener('click', () => {
          console.log('MetaCapi');
          window.umami.track('buy_now_click', {
            syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
            fingerprintId: window.__deviceId
          });
          trackMetaEvent(response.User_Analysis, "Expand Benefits");
          fireEvent("buy_now", caseId, {
            syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
            language: "english"
          });
      });
  });
  const cards = document.querySelectorAll(".real-story-card");
  cards.forEach((card, index) => {
    const video = card.querySelector("[data-video]");
    const videoURL = video.dataset.videoUrl;
    const playBtn = card.querySelector("[data-play]");
    playBtn.addEventListener("click", () => {
      fireEvent("testimonial_video_played", caseId, {
        videoURL: videoURL,
        videoPosition: index + 1
      });
    });
  });

  // Show new money-back banner, hide old checking-content
  var newMBBanner = document.querySelector('.moneyback-banner');
  var oldMBContent = document.querySelector('.checking-content');
  if (newMBBanner) {
    newMBBanner.style.display = 'block';
    var _mbContainer = document.querySelector('.checking-container');
    var _mbSection = document.querySelector('.eligibility-check--section');
    if (_mbContainer) _mbContainer.classList.add('moneyback-banner-active');
    if (_mbSection) _mbSection.classList.add('moneyback-banner-active');
  }
  if (oldMBContent) oldMBContent.style.display = 'none';
}

// ===== Future Kit Routine Switcher =====
function FutureKitRoutine(maxMonths) {

  const section = document.querySelector('[id^="future-kit-routine-"]');
  if (!section) return;

  const deskImg = section.querySelector('.future-kit-img--desk');
  const mobImg  = section.querySelector('.future-kit-img--mob');

  // Bundle → images mapping (YOU control this)
  const FUTURE_KIT_IMAGES = {
    5: {
      desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_3_f85dfd3e-2878-45c7-aad9-d67a6429ff7b.webp',
      mob:  'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_2_fed1e1e3-5163-43dc-bce4-070ebac97d40.webp'
    },
    8: {
      desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_5.webp?v=1766991051',
      mob:  'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_4_b96d31a7-587c-489d-960a-a7e0b8b7e8eb.webp'
    },
    12: {
      desk: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_8.webp',
      mob:  'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/banner_7.webp'
    }
  };

  if (!maxMonths || !FUTURE_KIT_IMAGES[maxMonths]) {
    console.warn('FutureKitRoutine: invalid maxMonths', maxMonths);
    return;
  }

  deskImg.src = FUTURE_KIT_IMAGES[maxMonths].desk;
  mobImg.src  = FUTURE_KIT_IMAGES[maxMonths].mob;
}

(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const attributes = {};

  urlParams.forEach((value, key) => {
    if (key.startsWith('utm_') && value) {
      try { localStorage.setItem(key, value); } catch (e) {}
    }
  });

  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('utm_')) {
      const v = localStorage.getItem(key);
      if (v) attributes[key] = v;
    }
  });

  const explicitSynthetic = urlParams.get('syntheticId');
  const idParam = urlParams.get('id');
  const storedSynthetic = localStorage.getItem('syntheticId');
  const syntheticId = explicitSynthetic || idParam || storedSynthetic;

  if (syntheticId) {
    attributes.syntheticId = syntheticId;
    try { localStorage.setItem('syntheticId', syntheticId); } catch (e) {}
  }

  if (!Object.keys(attributes).length) return;

  function updateWhenCartIsReady() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        if ((cart.items && cart.items.length) || cart.item_count > 0) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes })
          })
          .then(r => r.json())
          .then(updated => {
            console.log('Cart attributes updated:', updated.attributes);
          });
        } else {
          console.log('Cart empty, retrying...');
          setTimeout(updateWhenCartIsReady, 1000);
        }
      })
      .catch(err => console.error('Failed to update cart attributes:', err));
  }

  updateWhenCartIsReady();
})();
function initVideoPopup() {

  const trigger = document.getElementById("videoTrigger");
  const popup = document.getElementById("videoPopup");
  const popupBackdrop = document.getElementById("popupBackdrop");
  const closePopup = document.getElementById("closePopup");
  const popupVideo = document.getElementById("popupVideo");
  const toggleBtn = document.getElementById("toggleBtn");
  const wrapper = document.getElementById("videoWrapper");
  const spinner = document.getElementById("videoSpinner");

  const videoSrc = "https://cdn.shopify.com/videos/c/o/v/a6b501608a0e48968b17b54f1a1cdf91.mp4";

  if (!popupVideo) return;

  popupVideo.setAttribute("src", videoSrc);
  popupVideo.load();

  function showSpinner() {
    spinner.classList.add("visible");
    toggleBtn.classList.add("hidden");
  }

  function hideSpinner() {
    spinner.classList.remove("visible");
  }

  popupVideo.addEventListener("waiting", showSpinner);
  popupVideo.addEventListener("stalled", showSpinner);
  popupVideo.addEventListener("canplay", hideSpinner);
  popupVideo.addEventListener("playing", hideSpinner);

  function playVideo() {
    if (popupVideo.readyState >= 3) {
      popupVideo.play();
      toggleBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="11" height="14" viewBox="0 0 9 12" fill="none">
          <path d="M7.83333 0.5H6.5C6.13181 0.5 5.83333 0.798477 5.83333 1.16667V10.5C5.83333 10.8682 6.13181 11.1667 6.5 11.1667H7.83333C8.20152 11.1667 8.5 10.8682 8.5 10.5V1.16667C8.5 0.798477 8.20152 0.5 7.83333 0.5Z" fill="#A4BF2C"/>
          <path d="M2.5 0.5H1.16667C0.798477 0.5 0.5 0.798477 0.5 1.16667V10.5C0.5 10.8682 0.798477 11.1667 1.16667 11.1667H2.5C2.86819 11.1667 3.16667 10.8682 3.16667 10.5V1.16667C3.16667 0.798477 2.86819 0.5 2.5 0.5Z" fill="#A4BF2C"/>
        </svg>`;
      toggleBtn.classList.add("show-on-hover");
      toggleBtn.classList.remove("hidden");
    } else {
      showSpinner();
      popupVideo.addEventListener("canplay", function onReady() {
        popupVideo.removeEventListener("canplay", onReady);
        hideSpinner();
        popupVideo.play();
        toggleBtn.textContent = "⏸";
        toggleBtn.classList.add("show-on-hover");
        toggleBtn.classList.remove("hidden");
      }, { once: true });
    }
  }

  trigger?.addEventListener("click", function () {
    popup.style.display = "flex";

    fireEvent("video_play", caseId, {
      syntheticId: window.location.search.substring(1).split('=')[1] || "default-id"
    });

    playVideo();
  });

  wrapper?.addEventListener("click", function (e) {
    e.stopPropagation();

    if (popupVideo.paused) {
      popupVideo.play();
      toggleBtn.textContent = "⏸";
      toggleBtn.classList.add("show-on-hover");
      toggleBtn.classList.add("hidden");
    } else {
      popupVideo.pause();
      toggleBtn.textContent = "▶";
      toggleBtn.classList.remove("hidden");
      toggleBtn.classList.remove("show-on-hover");
    }
  });

  function closeVideoPopup() {
    popup.style.display = "none";
    popupVideo.pause();
    popupVideo.currentTime = 0;
    toggleBtn.textContent = "▶";
    toggleBtn.classList.remove("show-on-hover");
    toggleBtn.classList.remove("hidden");
    hideSpinner();
  }

  closePopup?.addEventListener("click", closeVideoPopup);
  popupBackdrop?.addEventListener("click", closeVideoPopup);
}

document.addEventListener("DOMContentLoaded", function () {
  initVideoPopup();
  var atcButton2 = document.querySelector('#add-to-cart-result-page');
  atcButton2.disabled = true;
  const listItems = document.querySelectorAll(".f-b-main-li");
  const anchorLinks = document.querySelectorAll(".nav-link");
  const tabLinks = document.querySelectorAll(".tab-pane");

  listItems.forEach(function (item) {
    item.addEventListener("click", function () {
      const target = this.getAttribute("data-targets");
      triggerAction(target);
    });
  });

  function triggerAction(target) {
    anchorLinks.forEach(function (link) {
      if (link.getAttribute("data-targets") === target) {
        anchorLinks.forEach(function (link) {
          link.classList.remove("active");
        });
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });

    tabLinks.forEach(function (tab) {
      if (tab.getAttribute("data-targets") === target) {
        tabLinks.forEach(function (tab) {
          tab.classList.remove("active");
          tab.classList.remove("show");
        });
        tab.classList.add("active");
        tab.classList.add("show");
      } else {
        tab.classList.remove("active");
        tab.classList.remove("show");
      }
    });
  }
});

function cartData() {
  window.dataLayer = window.dataLayer || [];
  function gtag(){
    dataLayer.push(arguments);
  }
  fetch("/cart.js").then((cart) => {
    return cart.json();
  }).then((cart) => {
    var items = [];
    cart.items.forEach((item) => {
      items.push({
        "item_id": item.id,
        "item_name": item.title,
        "item_brand": "Traya Health",
        "item_category": "",
        "price": (parseInt(item.price) / 100),
        "quantity": item.quantity
      })
    });
    var eventData = {
      "currency": cart.currency,
      "value": (parseInt(cart.items_subtotal_price) / 100),
      "items": items
    };
    gtag("event", "view_cart", eventData);
  }).catch((error) => {
    console.error("Error: ", error);
  })
}

function showOrHide(partition, state) {
  partition.forEach((part) => {
    part.style.display = `${state}`;
  })
}


function initKitBannerCTA(response) {
  const caseId = String(response?.User_Analysis?.case_id).trim();
  if (!caseId) return;

  const kitBannerBtn = document.querySelector('.kit-banner');
  if (!kitBannerBtn) return;

  // Only show if Minoxidil recommendation is "yes"
  const isMinoxidil = String(response?.Recommendations?.Minoxidil).trim().toLowerCase() === 'yes';

  if (!isMinoxidil) {
    const section = kitBannerBtn.closest('section') || kitBannerBtn.closest('.kit-banner');
    if (section) section.style.display = 'none';
    return;
  }

  // ── Variation image swap based on caseId ──
  const VARIATION_DESKTOP = 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/3x_better_new3_desktop.webp?v=1786693281';
  const VARIATION_MOBILE  = 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/3x_better_new3_mobile.webp?v=1786693281';

  const bannerSection = kitBannerBtn.closest('section') || kitBannerBtn;
  const deskImg = bannerSection.querySelector('.kit-banner__img--desktop');
  const mobImg  = bannerSection.querySelector('.kit-banner__img--mobile');
  if (deskImg) deskImg.src = VARIATION_DESKTOP;
  if (mobImg)  mobImg.src  = VARIATION_MOBILE;

  // Minoxidil = yes → intercept click, show popup + fire MoEngage
  prefetchKitBannerPage();
  kitBannerBtn.addEventListener('click', function (e) {
    e.preventDefault();

    // MoEngage event
    const urlParams = new URLSearchParams(window.location.search);
    const syntheticId = urlParams.get('id') || 'default-id';
    const utmSource = urlParams.get('utm_source') || urlParams.get('source') || urlParams.get('url_source') || null;
    const rpUrl = window.location.origin + window.location.pathname + '?id=' + caseId;

    fetch('https://public-jgfas325.hav-g.in/eventMoengageWeb', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90'
      },
      body: JSON.stringify({
        eventName: 'know_how_click',
        eventAttributes: {
          generalAttributes: {
            platform: 'web_shopify',
            domain: 'traya.health',
            syntheticId: syntheticId,
            rp_url: rpUrl,
            caseId: caseId,
            utm_source: utmSource
          }
        },
        caseId: caseId
      })
    }).catch(err => console.error('MoEngage event error:', err));

    openKitBannerPopup();
  });
}

async function prefetchKitBannerPage() {
  try {
    const res = await fetch('/pages/better-than-minoxidil');
    if (!res.ok) throw new Error('Fetch failed');

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const pageContent =
      doc.querySelector('.page-width') ||
      doc.querySelector('main') ||
      doc.body;

    kitBannerCachedHTML = pageContent.innerHTML;
    kitBannerIsReady = true;
    console.log('✅ Kit Banner page prefetched');
  } catch (err) {
    console.error('Kit Banner prefetch failed:', err);
  }
}

function openKitBannerPopup() {
  if (!kitBannerIsReady) {
    window.location.href = '/pages/better-than-minoxidil';
    return;
  }

  let popup = document.getElementById('kit-banner-popup');
  let overlay = document.getElementById('kit-banner-overlay');

  if (!popup) {
    overlay = document.createElement('div');
    overlay.id = 'kit-banner-overlay';
    overlay.className = 'kit-banner-popup-overlay';

    popup = document.createElement('div');
    popup.id = 'kit-banner-popup';
    popup.className = 'kit-banner-popup';
    popup.innerHTML = `
      <div class="kit-banner-popup__header">
       <div class="clinical-study__handle-bar">
       <span class="clinical-study__handle"></span>
        </div>
        <button class="kit-banner-popup__close" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="kit-banner-popup__content" id="kit-banner-popup-content"></div>
    `;

    document.body.appendChild(overlay);
    document.body.appendChild(popup);

    popup.querySelector('.kit-banner-popup__close').addEventListener('click', closeKitBannerPopup);
    overlay.addEventListener('click', closeKitBannerPopup);
  }

  document.getElementById('kit-banner-popup-content').innerHTML = kitBannerCachedHTML;

  popup.classList.add('show');
  overlay.classList.add('show');
  document.body.style.overflow = 'hidden';
}

function closeKitBannerPopup() {
  const popup = document.getElementById('kit-banner-popup');
  const overlay = document.getElementById('kit-banner-overlay');

  if (popup) popup.classList.remove('show');
  if (overlay) overlay.classList.remove('show');
  document.body.style.overflow = '';
}


// ===== Kit Banner Mobile Reorder =====
function reorderKitBannerForMobile() {
  if (window.innerWidth > 767) return;

  const kitBannerBtn = document.querySelector('.kit-banner');
  if (!kitBannerBtn) return;

  // Grab the closest parent section/wrapper of the kit-banner button
  const kitBannerSection = kitBannerBtn.closest('section') || kitBannerBtn.parentElement;
  if (!kitBannerSection) return;

  // Target: .result-product-kit-wrapper → inside it, .shopify-kit-section (the product list)
  const kitWrapper = document.querySelector('.result-product-kit-wrapper');
  if (!kitWrapper) return;

  // Insert the kit-banner section right after the kit wrapper
  kitWrapper.insertAdjacentElement('afterend', kitBannerSection);
}

// experiment 
const VARIANT_CONTENT = [
  {
    tag: "Personal Hair Coach",
    text: "Dedicated on-call support from Day 1 till you see visible results",
    price: "₹300",
    imgSrc: "//traya.health/cdn/shop/files/Product_1_833856d7-3c27-4b39-9a48-a8867e336a0e.webp?v=1775214970",
    imgWidth: "252",
    imgHeight: "252",
  },
  {
    tag: "Daily Meal Plan",
    text: "Nourish hair follicles from within through meals you already love",
    price: "₹100",
    imgSrc: "//traya.health/cdn/shop/files/Meal.webp?v=1775214971",
    imgWidth: "336",
    imgHeight: "336",
  },
  {
    tag: "Hair Specialist Approval",
    text: "Senior specialists fine-tune your kit for best results before it reaches you",
    price: "₹100",
    imgSrc: "//traya.health/cdn/shop/files/Product_5e498cd2-a16a-4fa1-a712-c1871628ce81.webp?v=1775214970",
    imgWidth: "336",
    imgHeight: "336",
  },
];

function updateHairThinningKit() {
  const containers = document.querySelectorAll(
    ".hair_thinning_kit--image-container"
  );
  containers.forEach((container, index) => {
    const variant = VARIANT_CONTENT[index];
    if (!variant) return;

    const tag = container.querySelector(".hair_thinning_kit--tag-container");
    if (tag) tag.textContent = variant.tag;

    const text = container.querySelector(".hair_thinning_kit--text-container");
    if (text) text.textContent = variant.text;

    const price = container.querySelector(".hair_thining_kit--price");
    if (price) price.textContent = variant.price;

    const picture = container.querySelector("picture");
    if (picture) {
      picture.querySelectorAll("source").forEach((source) => {
        const widthDescriptor = source.getAttribute("srcset")?.match(/\s+\d+w$/)?.[0] ?? "";
        source.setAttribute("srcset", `${variant.imgSrc}${widthDescriptor}`);
      });
      const img = picture.querySelector("img");
      if (img) {
        img.setAttribute("src", `${variant.imgSrc}&width=1500`);
        img.setAttribute("width", variant.imgWidth);
        img.setAttribute("height", variant.imgHeight);
      }
    }
  });
}

function initResult4bYouSave(response) {
  const isResult4b = document.body.classList.contains('result4b') ||
    window.location.pathname.includes('result4b') ||
    document.querySelector('#sticky-btn.ss5');
  if (!isResult4b) return;

  const stickyBtn = document.getElementById('sticky-btn');
  if (!stickyBtn) return;

  const strikeEl = stickyBtn.querySelector('.strike-cart-total-price');
  const totalEl  = stickyBtn.querySelector('.total-price');
  const iotEls   = document.querySelectorAll('.iot_text');
  const priceInc = stickyBtn.querySelector('.price-inc');
  let wrapEl     = stickyBtn.querySelector('.you-save-text');

  if (!strikeEl || !totalEl || !priceInc) return;

  if (!wrapEl) {
    wrapEl = document.createElement('p');
    wrapEl.className = 'you-save-text';
    wrapEl.innerHTML = 'You save <span class="you-save-amount">₹--</span>';
    priceInc.appendChild(wrapEl);
  }
  const saveEl = wrapEl.querySelector('.you-save-amount');

  const parseRupees = (el) => parseFloat((el?.textContent || '').replace(/[^\d.]/g, '')) || 0;

  const update = () => {
    const save = Math.max(0, Math.round(parseRupees(strikeEl) - parseRupees(totalEl)));
    saveEl.textContent = '₹' + save.toLocaleString('en-IN');
    wrapEl.style.display = save > 0 ? '' : 'none';
    iotEls.forEach(el => save > 0
      ? el.style.setProperty('display', 'none', 'important')
      : el.style.removeProperty('display'));
  };

  update();

  const observer = new MutationObserver(update);
  [strikeEl, totalEl].forEach(el => observer.observe(el, { childList: true, characterData: true, subtree: true }));
}

// ═══════════════════════════════════════════════════════════════════
// Stage Progression Experiment (A/B test)
// ───────────────────────────────────────────────────────────────────
// Variant routing (by case_id first char, lowercased):
//   v1           → 8, 9, a, b      (hairAIData.image_b64 present)
//   v2           → c, d, e, f      (hairAIData.image_b64 present)
//   non-hair-ai  → same as v1/v2 cases when hairAIData.image_b64 missing
// ═══════════════════════════════════════════════════════════════════
// Shared S1–S6 thumbnails used by V1 transition + V2/non-hair-ai progress bar
const SPE_STATIC_STAGE_IMAGES = {
  1: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/S1.webp?v=1778658346',
  2: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/S2.webp?v=1778658346',
  3: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/S3.webp?v=1778658345',
  4: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/S4.webp?v=1778658347',
  5: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/S5_9d60dcb5-b76f-4c0c-a4c0-980297a2e1c8.webp?v=1778656101',
  6: 'https://cdn.shopify.com/s/files/1/0100/1622/7394/files/S6.webp?v=1778656070',
};

function initStageProgressionExperiment(response) {
  try {
    const stage = response?.currentStage?.stage || response?.User_Analysis?.stage;
    const gender = response?.User_Analysis?.gender;

    if (stage !== 'Stage-5') {
      console.log('[StageProgressionExperiment] stage:', stage, '→ skip (Stage-5 only)');
      return;
    }
    if (gender !== 'M') {
      console.log('[StageProgressionExperiment] gender:', gender, '→ skip (male only)');
      return;
    }

    const caseId = String(response?.User_Analysis?.case_id || '').trim();
    if (!caseId) return;

    const firstChar = caseId.charAt(0).toLowerCase();
    const V1_CHARS = ['0', '1', '2', '3', '4', '5', '6', '7',
                      '8', '9', 'a', 'b', 'c', 'd', 'e', 'f']; // all case IDs (100%)

    let baseVariant = null;
    if (V1_CHARS.includes(firstChar)) baseVariant = 'v1'; // 100% of case IDs → in cohort

    if (!baseVariant) {
      console.log('[StageProgressionExperiment] caseId:', caseId, '→ not in cohort');
      return;
    }

    const hasHairAI = !!response?.hairAIData?.image_b64;
    const variant = 'v1'; // everyone gets V1 (arrow transition) design; only the header image differs

    console.log('[StageProgressionExperiment] caseId:', caseId,
                '→ variant: v1 (hasHairAI:', hasHairAI, ')');

    renderStageProgressionExperiment(response, variant);
  } catch (err) {
    console.error('[StageProgressionExperiment] init error:', err);
  }
}

function renderStageProgressionExperiment(response, variant) {
  const userName = response?.User_Analysis?.first_name || '';
  const stageRaw = response?.currentStage?.stage || 'Stage-5';
  const stageNumMatch = String(stageRaw).match(/\d+/);
  const stageNum = stageNumMatch ? parseInt(stageNumMatch[0], 10) : 5;
  const maxMonths = response?.Recommendations?.Max_months || 5;

const hairAIImage = response?.hairAIData?.image_b64
    ? `data:image/jpeg;base64,${response.hairAIData.image_b64}`
    : null;

  const stageAvatars = resolveStageAvatars(response);

  // Avatar (no-upload) image must come from the response, not the static CDN fallback.
  const responseAvatar = response?.currentStage?.imgUrl
                      || response?.User_Analysis?.imgUrl
                      || '';

  // Uploaded photo wins; otherwise use the response avatar (static map only as last resort).
  const headerImage = hairAIImage || responseAvatar || stageAvatars[stageNum];

  const headerHTML = buildSPEHeaderHTML({
    variant, userName, stageNum, maxMonths, headerImage,
    isAvatar: !hairAIImage // no upload → avatar (default-image) styling
  });

  // 100% → V1 (arrow transition) design for both uploaders and non-uploaders.
  const bodyHTML = buildSPEV1BodyHTML(stageNum, stageAvatars, response);

  const experimentHTML = `
    <section class="stage-progression-experiment ${variant}">
      ${headerHTML}
      ${bodyHTML}
    </section>
  `;

  const resultsBar = document.querySelector('.results-ui-update');
  if (!resultsBar) {
    console.warn('[StageProgressionExperiment] .results-ui-update not found — aborting.');
    return;
  }

  resultsBar.insertAdjacentHTML('beforebegin', experimentHTML);

  // Hide the original duplicate header row (name / stage / hair AI image)
  const originalHeroRow = document.querySelector('.container.pt-4.text-white.d-flex');
  if (originalHeroRow) originalHeroRow.style.setProperty('display', 'none', 'important');

  // Stage 5 SPE replaces the stage description text — hide it
  document.querySelectorAll('.stageDescription_text').forEach(el => {
    el.style.setProperty('display', 'none', 'important');
  });

  const insertedSection = resultsBar.previousElementSibling;

  // On desktop, move the "93% Saw Results" bar inside the SPE card, below the callout.
  // The bar already has `d-none d-md-block`, so it stays hidden on mobile and shows on desktop.
  const growthBar = document.querySelector('.cstm-growthPossibilityBar.progress');
  const calloutEl = insertedSection?.querySelector('.spe-callout');
  if (growthBar && calloutEl) {
    calloutEl.insertAdjacentElement('afterend', growthBar);
  }

  insertedSection?.querySelector('[data-spe-action="scroll-to-kit"]')
    ?.addEventListener('click', function (e) {
      e.preventDefault();
      const kit = document.querySelector('.shopify-kit-section')
               || document.querySelector('.result-product-kit-wrapper')
               || document.querySelector('#sticky-btn');
      kit?.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
    });

  // Only wire the zoom popup when there's a real uploaded photo.
  if (hairAIImage) {
    const headerImageWrap = insertedSection?.querySelector('.spe-header__image-wrap');
    const speImg = headerImageWrap?.querySelector('img');
    const hairAiPopup = document.getElementById('hairAiPopup');
    const popupHairImage = document.getElementById('popupHairImage');

    if (headerImageWrap && speImg && hairAiPopup && popupHairImage) {
      headerImageWrap.style.cursor = 'pointer';
      headerImageWrap.addEventListener('click', function () {
        hairAiPopup.classList.add('active');
        popupHairImage.src = speImg.src;
        fireEvent('image_click', caseId, {
          syntheticId: window.location.search.substring(1).split('=')[1] || 'default-id',
          language: 'english'
        });
      });
    }
  }
}

function buildSPEHeaderHTML(opts) {
  const imageWrapClass = opts.isAvatar
    ? 'spe-header__image-wrap spe-header__image-wrap--avatar'
    : 'spe-header__image-wrap';

  const nameLine = opts.userName
    ? `<p class="spe-header__name">${speEscapeHTML(opts.userName)}</p>`
    : '';

  return `
    <div class="spe-header">
      <div class="${imageWrapClass}">
        <img src="${opts.headerImage}" alt="Your hair fall visual"
             class="spe-header__image" loading="eager" />
      </div>
      <div class="spe-header__info">
        ${nameLine}
        <p class="spe-header__label">Your hair fall is at</p>
        <p class="spe-header__stage">Stage ${opts.stageNum}</p>
        <p class="spe-header__label result_see">Start seeing results in</p>
       <p class="spe-header__duration">${opts.maxMonths} months</p>
      </div>
    </div>
  `;
}


function buildSPEV1BodyHTML(stageNum, stageAvatars, response) {
  const nextStageNum = Math.min(stageNum + 1, 6);

  const currentImg = SPE_STATIC_STAGE_IMAGES[stageNum] || '';
  const nextImg = SPE_STATIC_STAGE_IMAGES[nextStageNum] || '';

  return `
  <div class="spe-main">
    <div class="spe-transition">
      <div class="spe-transition__stage spe-transition__stage--current">
        <div class="spe-transition__stage-img">
          <img src="${currentImg}" alt="Stage ${stageNum}" />
          <p class="spe-transition__stage-label">Stage ${stageNum}</p>
        </div>
      </div>
      <div class="spe-transition__arrow">
        <p class="spe-transition__arrow-text">This is your last chance to act</p>
        <svg class="spe-transition__arrow-svg" viewBox="0 0 200 12"
             preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <line x1="0" y1="6" x2="190" y2="6" stroke="#1A1A1A" stroke-width="1.5" />
          <polyline points="184,1 196,6 184,11" stroke="#1A1A1A" stroke-width="1.5"
                    fill="none" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <div class="spe-transition__stage spe-transition__stage--next">
        <div class="spe-transition__stage-img">
          <img src="${nextImg}" alt="Stage ${nextStageNum}" />
          <p class="spe-transition__stage-label">Stage ${nextStageNum}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="spe-callout">
    <p class="spe-callout__title">Your hair follicles can still be reactivated</p>
    <p class="spe-callout__text">
      By Stage ${nextStageNum}, 80% of your follicles have sealed,
      and hair growth stops.
       <span class="spe-callout__link">Act Now.</span>
    </p>
  </div>
  `;
}

function buildSPEV2BodyHTML(stageNum, stageAvatars) {
  return `
    <div class="spe-progress">
      ${buildSPEProgressInnerHTML(stageNum, stageAvatars)}
    </div>
    <div class="spe-callout">
      <p class="spe-callout__title">This is your last chance to act</p>
      <p class="spe-callout__text">
        By Stage 6, 80% of your follicles have sealed, and hair growth stops.
      </p>
    </div>
  `;
}

function buildSPENonHairAIBodyHTML(stageNum, stageAvatars) {
  return `
    <div class="spe-progress spe-progress--titled">
      <p class="spe-progress__heading">This is your last chance to act</p>
      ${buildSPEProgressInnerHTML(stageNum, stageAvatars)}
    </div>
    <div class="spe-callout">
      <p class="spe-callout__title">This is your last chance to act</p>
      <p class="spe-callout__text">
        By Stage 6, 80% of your follicles have sealed, and hair growth stops.
      </p>
    </div>
  `;
}

function buildSPEProgressInnerHTML(stageNum, stageAvatars) {
  const totalStages = 6;
  // Marker positions = stage centers in a 6-column grid.
  // Stage i center = (i - 0.5) / 6  → Stage 5 = 75%, Stage 6 = 91.67%
  const youPos = ((stageNum - 0.5) / totalStages) * 100;
  const severePos = ((totalStages - 0.5) / totalStages) * 100;

  let stagesHTML = '';
  for (let i = 1; i <= totalStages; i++) {
    const classes = ['spe-progress__stage'];
    if (i < stageNum) classes.push('is-faded');
    if (i === stageNum) classes.push('is-current');
    if (i === totalStages && i !== stageNum) classes.push('is-severe');

    stagesHTML += `
      <div class="${classes.join(' ')}">
        <div class="spe-progress__stage-img-wrap">
          <img src="${stageAvatars[i] || ''}" alt="Stage ${i}" />
        </div>
        <p class="spe-progress__stage-label">Stage ${i}</p>
      </div>
    `;
  }

  return `
    <div class="spe-progress__bar-wrap">
      <div class="spe-progress__bar">
        <div class="spe-progress__bar-fill" style="width: ${youPos.toFixed(2)}%;"></div>
      </div>
      <div class="spe-progress__marker spe-progress__marker--you"
           style="left: ${youPos.toFixed(2)}%;">
        <span class="spe-progress__marker-label">You</span>
        <span class="spe-progress__marker-dot spe-progress__marker-dot--you"></span>
      </div>
      <div class="spe-progress__marker spe-progress__marker--severe"
           style="left: ${severePos.toFixed(2)}%;">
        <span class="spe-progress__marker-label">Severe</span>
        <span class="spe-progress__marker-dot spe-progress__marker-dot--severe"></span>
      </div>
    </div>
    <div class="spe-progress__stages">${stagesHTML}</div>
  `;
}

function resolveStageAvatars(response) {
  // Prefer API stage-images array/map if present; fallback to Traya CDN thumbnails.
  const fromAPI = response?.stageAvatars || response?.stages || null;

  if (fromAPI && typeof fromAPI === 'object') {
    if (Array.isArray(fromAPI)) {
      const mapped = {};
      fromAPI.forEach((s) => {
        const n = s?.stage || s?.stageNumber;
        const url = s?.image || s?.imgUrl || s?.url;
        if (n && url) {
          const num = parseInt(String(n).match(/\d+/), 10);
          if (num) mapped[num] = url;
        }
      });
      if (Object.keys(mapped).length) {
        return Object.assign(getSPEStageAvatarFallback(), mapped);
      }
    } else {
      return Object.assign(getSPEStageAvatarFallback(), fromAPI);
    }
  }

  return getSPEStageAvatarFallback();
}

function getSPEStageAvatarFallback() {
  return { ...SPE_STATIC_STAGE_IMAGES };
}

function speEscapeHTML(str) {
  return String(str).replace(/[&<>"']/g, (ch) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[ch]);
}



// ── 90+ Day Retake Logic ──────────────────────────────────────────────────
// Triggered when secondLastFormFilledDate is 90+ days old.
//  - Stage worsened  → red banner   (variation bucket only)
//  - Stage unchanged → yellow banner (variation bucket only)
//  - Stage improved  → no-op (handled on result4 / result4b)
//
// Experiment: banner is shown ONLY to caseIds starting with d/e/f/1/5/6/7/9.
// Control bucket still fires the dayflt90+ event so the experiment is measurable.

function getRetakeExperimentBucket(caseId) {
 const firstChar = String(caseId || '').charAt(0).toLowerCase();
  const VARIATION_CHARS = new Set(['8','9','a','b','c','d','e','f']);
  return VARIATION_CHARS.has(firstChar) ? 'variation' : 'control';
}

function check90DayRetake(response) {
  const secondLastFormFilledDate = response?.previousFormFilledDate;
  if (!secondLastFormFilledDate) return null;

  const daysSinceLast = getDaysSince(secondLastFormFilledDate);
  if (daysSinceLast < 90) return null;

  const previousStage = response?.previousFormFilledStage;
  const currentStage =
    response?.User_Analysis?.stage ?? response?.currentStage?.stage;

  if (!previousStage || !currentStage) return null;

  const oldNum = parseInt(String(previousStage).match(/\d+/)?.[0]);
  const newNum = parseInt(String(currentStage).match(/\d+/)?.[0]);
  if (Number.isNaN(oldNum) || Number.isNaN(newNum)) return null;

  let scenario;
  if (newNum > oldNum) scenario = 'worsened';
  else if (newNum === oldNum) scenario = 'unchanged';
  else return null; // improved → handled elsewhere

  const caseId = String(response?.User_Analysis?.case_id || '').trim();
  const exp = getRetakeExperimentBucket(caseId);

  return {
    scenario,
    oldStageNum: oldNum,
    newStageNum: newNum,
    secondLastFormFilledDate,
    daysSinceLast,
    caseId,
    exp,
  };
}

function renderRetakeBanner(outcome) {
  // Experiment gate — only variation bucket sees the banner
  if (outcome.exp !== 'variation') {
    console.log('[RetakeBanner] control bucket, skipping render', { caseId: outcome.caseId });
    return;
  }

  const dateStr = format90DayRetakeDate(outcome.secondLastFormFilledDate);

  const buildBannerHTML = (o) => o.scenario === 'worsened'
    ? `
      <span class="retake-banner__icon" aria-hidden="true">🛑</span>
      <div class="retake-banner__body">
        <p class="retake-banner__title">Hair fall has worsened : Stage ${o.oldStageNum} → ${o.newStageNum}</p>
        <p class="retake-banner__sub">Since last test taken on ${dateStr}</p>
      </div>
    `
    : `
      <span class="retake-banner__icon" aria-hidden="true">⚠️</span>
      <div class="retake-banner__body">
        <p class="retake-banner__title">Your hair fall has not improved</p>
        <p class="retake-banner__sub">Since last test taken on ${dateStr}</p>
      </div>
    `;

  // Mobile — before .results-ui-update.d-md-none
  const mobileTarget = document.querySelector('.results-ui-update.d-md-none');
  if (mobileTarget) {
    const mobileBanner = document.createElement('div');
    mobileBanner.className = `retake-banner retake-banner--${outcome.scenario} d-md-none`;
    mobileBanner.innerHTML = buildBannerHTML(outcome);
    mobileTarget.parentNode.insertBefore(mobileBanner, mobileTarget);
  } else {
    console.warn('[RetakeBanner] mobile target .results-ui-update.d-md-none not found');
  }

  // Desktop — before .cstm-growthPossibilityBar.progress.d-none.mb-2
  const desktopTarget = document.querySelector('.cstm-growthPossibilityBar.progress.d-none.mb-2');
  if (desktopTarget) {
    const desktopBanner = document.createElement('div');
    desktopBanner.className = `retake-banner retake-banner--${outcome.scenario} d-none d-md-flex`;
    desktopBanner.innerHTML = buildBannerHTML(outcome);
    desktopTarget.parentNode.insertBefore(desktopBanner, desktopTarget);
  } else {
    console.warn('[RetakeBanner] desktop target .cstm-growthPossibilityBar.progress.d-none.mb-2 not found');
  }
}

function format90DayRetakeDate(dateStr) {
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return '';
  const day = d.getDate();
  const months = ['January','February','March','April','May','June',
                  'July','August','September','October','November','December'];
  const j = day % 10, k = day % 100;
  let suffix = 'th';
  if (j === 1 && k !== 11) suffix = 'st';
  else if (j === 2 && k !== 12) suffix = 'nd';
  else if (j === 3 && k !== 13) suffix = 'rd';
  return `${day}${suffix} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

function fireRetake90DaysEvent(outcome, response) {
  console.log('[dayflt90+] firing', { outcome, caseId: outcome.caseId });
  if (!outcome.caseId) return;

  const hairfallMap = { worsened: 'worsened', unchanged: 'not improved' };

  fireEvent('dayflt90+', outcome.caseId, {
    exp: outcome.exp,
    old_stage: `Stage-${outcome.oldStageNum}`,
    new_stage: `Stage-${outcome.newStageNum}`,
    hairfall: hairfallMap[outcome.scenario],
    time_difference_days: outcome.daysSinceLast,
    syntheticId: new URLSearchParams(window.location.search).get('id') || 'default-id'
  });
}


// ── Sticky Note Variation ──────────────────────────────────────────────────
// Shows the value banner (₹XX / day) for all case IDs NOT starting with 0–7
// (i.e. first char in 8, 9, a, b, c, d, e, f). All 0–7 case IDs → control.
//
// Eligible cohort only: the .iso-note div is moved INTO the kit section (white
// card) as its last child, so it sits inside the card below the product cards.
// The ₹/day banner remains in the sticky footer where the iso-note was.
//
// NOTE: per-day price uses the SAME /34 divisor as resultMonthKit's
// `devidePriceCart`. Change the divisor below if that ever changes.
 
function initStickyNoteVariation(response) {
  // Declared locally so this function is self-contained and portable between
  // result4b.js / result4c.js (avoids "STICKY_NOTE_PER_DAY_DIVISOR is not defined").
  const STICKY_NOTE_PER_DAY_DIVISOR = 34;
 
  const caseId = String(response?.User_Analysis?.case_id || '').trim();
  if (!caseId) return;
 
  const firstChar = caseId.charAt(0).toLowerCase();
 
  // new case id's change 
 const ELIGIBLE_CHARS = new Set(['0', '1', '2', '3', '4', '5', 'e', 'f']);
  
  if (!ELIGIBLE_CHARS.has(firstChar)) {
    console.log('[StickyNoteVariation] caseId:', caseId, '→ control (no banner)');
    return;
  }
 
  // There can be multiple .iso-note nodes; on these templates it's one per page.
  const isoNotes = document.querySelectorAll('.iso-note');
  if (!isoNotes.length) {
    console.warn('[StickyNoteVariation] .iso-note not found.');
    return;
  }
 
  const perDay = Math.round(Number(response.cart_price) / STICKY_NOTE_PER_DAY_DIVISOR);
  if (!Number.isFinite(perDay) || perDay <= 0) {
    console.warn('[StickyNoteVariation] invalid per-day price, skipping.');
    return;
  }
 
  const bannerHTML = `
    <span class="sticky-note-variation__icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
           fill="none" stroke="#3C5A2E" stroke-width="1.8"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82Z"/>
        <circle cx="7" cy="7" r="1.4" fill="#3C5A2E" stroke="none"/>
      </svg>
    </span>
    <span class="sticky-note-variation__text">
      Start your journey with just <strong>₹${perDay} / day</strong>
    </span>
  `;
 
  isoNotes.forEach((isoNote) => {
    const parent = isoNote.parentElement;
    // Guard: don't insert a second sticky banner into the same sticky bar.
    if (parent?.querySelector(':scope > .sticky-note-variation')) return;
 
    const banner = document.createElement('div');
    banner.className = 'sticky-note-variation sticky-note-variation--v1';
    banner.innerHTML = bannerHTML;
    // Drop the ₹/day banner where the iso-note currently sits (inside #sticky-btn).
    isoNote.insertAdjacentElement('afterend', banner);
  });
 
  // ── Move the iso-note div INSIDE the kit section (white card) ──
  moveIsoNoteIntoKitSection(isoNotes[0]);
 
  console.log('[StickyNoteVariation] caseId:', caseId, '→ v1 (price/day)');
}
 
// Relocates the iso-note div INSIDE the kit section (white card), appended as
// its last child after the product cards, and applies the grey-box styling
// inline so no stylesheet change is needed. Retries briefly since the kit
// section is built in resultMonthKit which also runs during getMaleResult and
// may not exist yet at move time.
function moveIsoNoteIntoKitSection(isoNote, attempt = 0) {
  if (!isoNote) return;
 
  const kitSection = document.querySelector('.shopify-kit-section');
  if (!kitSection) {
    if (attempt < 10) {
      setTimeout(() => moveIsoNoteIntoKitSection(isoNote, attempt + 1), 100);
    } else {
      console.warn('[StickyNoteVariation] .shopify-kit-section not found — skip move.');
    }
    return;
  }
 
  // Grey-box styling applied inline (matches the screenshot + ayurvedic banner).
  // setProperty avoids stacking duplicates across retries.
  // NOTE: setProperty values must NOT include a trailing ';' (e.g. '92%' not '92%;').
  isoNote.style.setProperty('box-sizing', 'border-box');
  isoNote.style.setProperty('width', '100%');
  isoNote.style.setProperty('margin', '12px auto 12px');
  isoNote.style.setProperty('padding', '6px 8px');
  isoNote.style.setProperty('background', '#F7F7F7');
  // isoNote.style.setProperty('border', '1px solid #EDEDED');   // match .ayurvedic-tag-banner border
  isoNote.style.setProperty('border-radius', '4px');
  isoNote.style.setProperty('text-align', 'center');
  // Typography — OLD/Label/Medium
  isoNote.style.setProperty('color', '#5C5C5C');
  isoNote.style.setProperty('font-family', '"Nunito Sans"');
  isoNote.style.setProperty('font-size', '12px');
  isoNote.style.setProperty('font-style', 'normal');
  isoNote.style.setProperty('font-weight', '500');
  isoNote.style.setProperty('line-height', '16px');
  isoNote.style.setProperty('letter-spacing', '0.12px');
 
  // Already placed as the last child of the kit section
  if (isoNote.parentElement === kitSection && kitSection.lastElementChild === isoNote) return;
 
  kitSection.appendChild(isoNote);
  console.log('[StickyNoteVariation] iso-note moved inside .shopify-kit-section.');
}

function updateAddonPricesForVariation(response) {
  const caseId = String(response?.User_Analysis?.case_id || '').trim();
  if (!caseId) return;

  // Apply to ALL case IDs (100%) — no cohort gating.
  const OVERRIDES = [
    { keywords: ['coach'],         price: '₹400' },
    { keywords: ['diet', 'meal'],  price: '₹200' },
  ];

  const apply = () => {
    const containers = document.querySelectorAll('.hair_thinning_kit--image-container');
    if (!containers.length) { console.warn('[AddonPriceVariation] cards not in DOM yet'); return; }
    let changed = 0;
    containers.forEach((container) => {
      const tagEl = container.querySelector('.hair_thinning_kit--tag-container');
      const priceEl = container.querySelector('.hair_thining_kit--price'); // "thining" typo matches markup
      if (!tagEl || !priceEl) return;
      const tag = tagEl.textContent.trim().toLowerCase();
      const rule = OVERRIDES.find(o => o.keywords.some(k => tag.includes(k)));
      if (rule && priceEl.textContent.trim() !== rule.price) {
        priceEl.textContent = rule.price;
        changed++;
      }
    });
    console.log('[AddonPriceVariation] caseId:', caseId, '→ applied, changed:', changed);
  };

  apply();
  requestAnimationFrame(apply); // re-apply after any later rewrite (e.g. updateHairThinningKit)
}